(function() {
    // Get section ID from the DOM element
    const studioElement = document.querySelector('[data-section-id]');
    const sectionId = studioElement ? studioElement.getAttribute('data-section-id') : 'default';
    const designOverlay = document.getElementById(`designOverlay-${sectionId}`);
    const designText = document.getElementById(`designText-${sectionId}`);
    const textInput = document.getElementById(`textInput-${sectionId}`);
    const imageUpload = document.getElementById(`imageUpload-${sectionId}`);
    const sizeSlider = document.getElementById(`sizeSlider-${sectionId}`);
    const rotateSlider = document.getElementById(`rotateSlider-${sectionId}`);
    const sizeValue = document.getElementById(`sizeValue-${sectionId}`);
    const rotateValue = document.getElementById(`rotateValue-${sectionId}`);
    const resetBtn = document.getElementById(`resetBtn-${sectionId}`);
    const undoBtn = document.getElementById(`undoBtn-${sectionId}`);
    const guideBtn = document.getElementById(`guideBtn-${sectionId}`);
    const placementGuide = document.getElementById(`placementGuide-${sectionId}`);
    const hexInput = document.getElementById(`hexInput-${sectionId}`);
    const hexPreview = document.getElementById(`hexPreview-${sectionId}`);
    const hexCopyBtn = document.getElementById(`hexCopyBtn-${sectionId}`);
    const contrastInfo = document.getElementById(`contrastInfo-${sectionId}`);
    const contrastWhite = document.getElementById(`contrastWhite-${sectionId}`);
    const contrastBlack = document.getElementById(`contrastBlack-${sectionId}`);
    const contrastWarning = document.getElementById(`contrastWarning-${sectionId}`);
    const recentSwatches = document.getElementById(`recentSwatches-${sectionId}`);
    const brightnessSlider = document.getElementById(`brightnessSlider-${sectionId}`);
    const flipHBtn = document.getElementById(`flipHBtn-${sectionId}`);
    const flipVBtn = document.getElementById(`flipVBtn-${sectionId}`);
    const invertBtn = document.getElementById(`invertBtn-${sectionId}`);
    const tshirtImage = document.getElementById(`tshirtImage-${sectionId}`);
    
    // Canvas Zoom Elements
    const canvasZoomSlider = document.getElementById(`canvasZoom-${sectionId}`);
    const zoomValue = document.getElementById(`zoomValue-${sectionId}`);
    const zoomInBtn = document.getElementById(`zoomInBtn-${sectionId}`);
    const zoomOutBtn = document.getElementById(`zoomOutBtn-${sectionId}`);
    const mockupCanvas = document.getElementById(`mockupCanvas-${sectionId}`);

    let uploadedImage = null;
    let currentFont = "'Bebas Neue', sans-serif";
    let currentColor = '#000000';
    let flipH = false;
    let flipV = false;
    let inverted = false;
    let guideActive = false;
    let tshirtColor = 'white';
    let currentView = 'front';
    
    // Undo history
    let undoHistory = [];
    const MAX_UNDO = 20;

    // ============================================
    // CHARACTER COUNTER
    // ============================================
    
    const charCountDisplay = document.getElementById(`charCount-${sectionId}`);
    
    // Character limits
    const CHAR_WARNING = 80;  // Show warning color (40% of max)
    const CHAR_DANGER = 100;  // Show danger color (50% of max)
    const CHAR_MAX = 200;     // Hard limit (set in HTML maxlength)
    
    // Update character counter
    function updateCharCounter() {
        if (!textInput || !charCountDisplay) return;
        
        const length = textInput.value.length;
        
        // Update text
        charCountDisplay.textContent = `${length} character${length !== 1 ? 's' : ''}`;
        
        // Update color based on length
        charCountDisplay.classList.remove('warning', 'danger');
        
        if (length >= CHAR_DANGER) {
            charCountDisplay.classList.add('danger');
        } else if (length >= CHAR_WARNING) {
            charCountDisplay.classList.add('warning');
        }
    }
    
    // Add event listener to text input for character counting
    if (textInput && charCountDisplay) {
        textInput.addEventListener('input', updateCharCounter);
        
        // Initialize counter on page load
        setTimeout(() => {
            updateCharCounter();
        }, 100);
        
        console.log('✅ Character counter initialized');
    }

    // ============================================
    // FONT SIZE CONTROL
    // ============================================
    
    const fontSizeSlider = document.getElementById(`fontSizeSlider-${sectionId}`);
    const fontSizeDisplay = document.getElementById(`fontSizeDisplay-${sectionId}`);
    const fontSizeIncrease = document.getElementById(`fontSizeIncrease-${sectionId}`);
    const fontSizeDecrease = document.getElementById(`fontSizeDecrease-${sectionId}`);
    
    let currentFontSize = 32; // Default font size
    
    // Update font size function
    function updateFontSize(size) {
        currentFontSize = size;
        if (designText) {
            designText.style.fontSize = size + 'px';
        }
        if (fontSizeDisplay) {
            fontSizeDisplay.textContent = size + 'px';
        }
        if (fontSizeSlider) {
            fontSizeSlider.value = size;
        }
    }
    
    // Font size slider
    if (fontSizeSlider) {
        fontSizeSlider.addEventListener('input', (e) => {
            updateFontSize(parseInt(e.target.value));
        });
        
        fontSizeSlider.addEventListener('change', () => {
            saveState();
        });
    }
    
    // Increase button
    if (fontSizeIncrease) {
        fontSizeIncrease.addEventListener('click', () => {
            const newSize = Math.min(96, currentFontSize + 2);
            updateFontSize(newSize);
            saveState();
        });
    }
    
    // Decrease button
    if (fontSizeDecrease) {
        fontSizeDecrease.addEventListener('click', () => {
            const newSize = Math.max(12, currentFontSize - 2);
            updateFontSize(newSize);
            saveState();
        });
    }
    
    console.log('✅ Font size control initialized');

    // ============================================
    // PRODUCT THUMBNAIL GALLERY
    // ============================================
    
    const productGallery = {
        views: [
            { id: 'front', label: 'Front', image: studioElement && studioElement.dataset.assetTshirtView ? studioElement.dataset.assetTshirtView : '/assets/tshirt-view.png' },
            { id: 'back', label: 'Back', image: "https://cdn.shopify.com/s/files/1/0644/9525/5650/files/back2.svg?v=1761514574" },
            { id: 'side', label: 'Side', image: studioElement && studioElement.dataset.assetWomenSide ? studioElement.dataset.assetWomenSide : '/assets/Women-side.png' },
            { id: 'model', label: 'Model', image: studioElement && studioElement.dataset.assetGirlModel ? studioElement.dataset.assetGirlModel : '/assets/Girl-Model.png' }
        ]
    };
    
    // Initialize thumbnail gallery
    function initializeThumbnailGallery() {
        const thumbnailGallery = document.getElementById(`thumbnailGallery-${sectionId}`);
        
        if (!thumbnailGallery) {
            console.warn('⚠️ Thumbnail gallery not found');
            return;
        }
        
        // Create thumbnails
        const thumbnailHTML = productGallery.views.map((view, index) => `
            <div class="cts-thumbnail-item-${sectionId} ${index === 0 ? 'active' : ''}" 
                 data-view="${view.id}">
                <img src="${view.image}" 
                     alt="${view.label}" 
                     class="cts-thumbnail-img-${sectionId}">
                <div class="cts-thumbnail-label-${sectionId}">${view.label}</div>
            </div>
        `).join('');
        thumbnailGallery.innerHTML = thumbnailHTML;
        
        // Add event listeners
        document.querySelectorAll(`.cts-thumbnail-item-${sectionId}`).forEach(thumb => {
            thumb.addEventListener('click', function() {
                const viewId = this.getAttribute('data-view');
                switchView(viewId);
            });
        });
        
        console.log('✅ Thumbnail gallery initialized with', productGallery.views.length, 'views');
    }
    
    // Switch between views
    function switchView(viewId) {
        currentView = viewId;
        const view = productGallery.views.find(v => v.id === viewId);
        
        if (view) {
            // Update t-shirt image with fade effect
            tshirtImage.style.opacity = '0';
            setTimeout(() => {
                tshirtImage.src = view.image;
                tshirtImage.style.opacity = '1';
                
                // Apply back-view scaling to image and container
                if (viewId === 'back') {
                    tshirtImage.classList.add('back-view');
                    tshirtContainer.classList.add('back-view');
                    
                    // Hide scrollbars on back view
                    const mockupCanvas = document.getElementById(`mockupCanvas-${sectionId}`);
                    const previewCard = mockupCanvas?.closest(`.cts-preview-card-${sectionId}`);
                    if (mockupCanvas) mockupCanvas.style.overflow = 'hidden';
                    if (previewCard) previewCard.style.overflow = 'hidden';
                } else {
                    tshirtImage.classList.remove('back-view');
                    tshirtContainer.classList.remove('back-view');
                    
                    // Restore scrollbars on other views
                    const mockupCanvas = document.getElementById(`mockupCanvas-${sectionId}`);
                    const previewCard = mockupCanvas?.closest(`.cts-preview-card-${sectionId}`);
                    if (mockupCanvas) mockupCanvas.style.overflow = 'auto';
                    if (previewCard) previewCard.style.overflow = 'auto';
                }
            }, 200);
            
            // Update active thumbnail states
            document.querySelectorAll(`.cts-thumbnail-item-${sectionId}`).forEach(thumb => {
                thumb.classList.toggle('active', thumb.getAttribute('data-view') === viewId);
            });
            
            checkBoundary();
            console.log(`🔄 Switched to view: ${view.label}`);
        }
    }

    // ============================================
    // SVG HEXAGONAL COLOR PICKER (Perfect Honeycomb Grid)
    // ============================================
    
    const SQRT3 = Math.sqrt(3);
    const HEX_RADIUS = 5;      // Number of hexagon rings
    const HEX_SIZE = 20;       // Pixel radius of each hexagon (pointy-top)
    const HEX_GAP = 1;         // Gap between hexagons (0-2px for perfect fit)
    const HEX_PADDING = 24;    // Padding around the grid
    
    // Pointy-top hex geometry constants
    const HEX_WIDTH = SQRT3 * HEX_SIZE;        // w = sqrt(3) * size
    const HEX_HEIGHT = 2 * HEX_SIZE;            // h = 2 * size
    const HEX_HORIZONTAL_STEP = HEX_WIDTH;      // horizontal step = w
    const HEX_VERTICAL_STEP = 1.5 * HEX_SIZE;   // vertical step = 1.5 * size
    const HEX_ODD_ROW_OFFSET = HEX_WIDTH / 2;   // odd rows offset by w / 2
    
    // HSV state for brightness control
    let pickerHue = 0;
    let pickerSat = 0;
    let pickerVal = 1;
    
    // Convert axial coordinates (q, r) to pixel position (pointy-top hex with perfect spacing)
    function axialToPixel(q, r, size) {
        // Pointy-top hex geometry formulas:
        // w = sqrt(3) * size
        // h = 2 * size
        // horizontal step = w
        // vertical step = 1.5 * size
        // odd rows offset by w / 2
        const w = SQRT3 * size;
        const x = size * (SQRT3 * q + SQRT3 / 2 * r);
        const y = size * (1.5 * r);
        return { x, y };
    }
    
    // Generate polygon points for a pointy-top hexagon centered at (cx, cy)
    function polygonPoints(cx, cy, size) {
        const points = [];
        // Pointy-top hex: start at top (0°), then rotate 60° each time
        for (let i = 0; i < 6; i++) {
            const angle = (Math.PI / 180) * (60 * i - 30);  // -30° to start at top
            const x = cx + size * Math.cos(angle);
            const y = cy + size * Math.sin(angle);
            points.push(`${x.toFixed(2)},${y.toFixed(2)}`);
        }
        return points.join(' ');
    }
    
    // Convert HSL to HEX
    function hslToHex(h, s, l) {
        s /= 100;
        l /= 100;
        const k = n => (n + h / 30) % 12;
        const a = s * Math.min(l, 1 - l);
        const f = n => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
        const r = Math.round(255 * f(0));
        const g = Math.round(255 * f(8));
        const b = Math.round(255 * f(4));
        return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    }
    
    // Convert HSV to HEX
    function hsvToHex(h, s, v) {
        s = Math.max(0, Math.min(1, s));
        v = Math.max(0, Math.min(1, v));
        const c = v * s;
        const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
        const m = v - c;
        let r = 0, g = 0, b = 0;
        if (0 <= h && h < 60) [r, g, b] = [c, x, 0];
        else if (60 <= h && h < 120) [r, g, b] = [x, c, 0];
        else if (120 <= h && h < 180) [r, g, b] = [0, c, x];
        else if (180 <= h && h < 240) [r, g, b] = [0, x, c];
        else if (240 <= h && h < 300) [r, g, b] = [x, 0, c];
        else [r, g, b] = [c, 0, x];
        const toHex = (n) => Math.round((n + m) * 255).toString(16).padStart(2, '0');
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }
    
    // Extract hue from axial coordinates
    function hueFromAxial(q, r) {
        const angle = Math.atan2(SQRT3 * (r + q / 2), 1.5 * q);
        return ((angle * 180) / Math.PI + 360) % 360;
    }
    
    // Extract saturation from axial coordinates
    function satFromAxial(q, r, radius) {
        const x = q;
        const y = -q - r;
        const z = r;
        const dist = Math.max(Math.abs(x), Math.abs(y), Math.abs(z));
        return dist === 0 ? 0 : Math.min(1, 0.9 * (dist / radius) + 0.1);
    }
    
    // Map axial coordinate to a color (hue by angle, lightness by distance)
    function colorForAxial(q, r, radius) {
        const x = q;
        const y = -q - r;
        const z = r;
        const dist = Math.max(Math.abs(x), Math.abs(y), Math.abs(z));
        const angle = Math.atan2(SQRT3 * (r + q / 2), 1.5 * q);
        const hue = ((angle * 180) / Math.PI + 360) % 360;
        const l = 85 - (dist / radius) * 40; // 85% at center to ~45% at edge
        const s = dist === 0 ? 0 : 80; // Neutral center
        return hslToHex(hue, s, l);
    }
    
    // Update brightness slider gradient
    function updateBrightnessSliderGradient() {
        const track = document.getElementById(`brightnessTrack-${sectionId}`);
        if (track) {
            const topColor = hsvToHex(pickerHue, pickerSat, 1);
            const bottomColor = '#000000';
            track.style.background = `linear-gradient(to bottom, ${topColor} 0%, ${bottomColor} 100%)`;
        }
    }
    
    // Build all hex cells in a disk of given radius
    function buildAxialHexDisk(radius) {
        const cells = [];
        for (let q = -radius; q <= radius; q++) {
            const r1 = Math.max(-radius, -q - radius);
            const r2 = Math.min(radius, -q + radius);
            for (let r = r1; r <= r2; r++) {
                cells.push({ q, r });
            }
        }
        return cells;
    }
    
    // Initialize SVG hexagonal picker with perfect honeycomb grid
    function initSVGHexagonalPicker() {
        const svg = document.getElementById(`hexSvg-${sectionId}`);
        const cells = buildAxialHexDisk(HEX_RADIUS);
        
        // Create magnifier element for mobile preview
        let magnifier = document.getElementById(`colorMagnifier-${sectionId}`);
        if (!magnifier) {
            magnifier = document.createElement('div');
            magnifier.id = `colorMagnifier-${sectionId}`;
            magnifier.className = `cts-color-magnifier-${sectionId}`;
            document.body.appendChild(magnifier);
        }
        
        // Calculate viewBox dimensions with perfect spacing
        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
        cells.forEach(({ q, r }) => {
            const { x, y } = axialToPixel(q, r, HEX_SIZE);
            const hexRadius = HEX_SIZE - HEX_GAP / 2;  // Account for gap
            minX = Math.min(minX, x - hexRadius);
            maxX = Math.max(maxX, x + hexRadius);
            minY = Math.min(minY, y - hexRadius);
            maxY = Math.max(maxY, y + hexRadius);
        });
        
        const viewBoxX = minX - HEX_PADDING;
        const viewBoxY = minY - HEX_PADDING;
        const viewBoxWidth = (maxX - minX) + 2 * HEX_PADDING;
        const viewBoxHeight = (maxY - minY) + 2 * HEX_PADDING;
        
        svg.setAttribute('viewBox', `${viewBoxX} ${viewBoxY} ${viewBoxWidth} ${viewBoxHeight}`);
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        
        // Use event delegation for better performance
        let selectedPolygon = null;
        
        // Create hexagon polygons with perfect spacing and visual polish
        cells.forEach(({ q, r }) => {
            const { x, y } = axialToPixel(q, r, HEX_SIZE);
            const fill = colorForAxial(q, r, HEX_RADIUS);
            const hexRadius = HEX_SIZE - HEX_GAP / 2;  // Slightly smaller to create gap
            const points = polygonPoints(x, y, hexRadius);
            const isCenter = q === 0 && r === 0;
            
            const polygon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
            polygon.setAttribute('points', points);
            polygon.setAttribute('fill', fill);
            polygon.setAttribute('stroke', 'rgba(255, 255, 255, 0.15)');  // Subtle outline
            polygon.setAttribute('stroke-width', '1');
            polygon.setAttribute('class', 'hex-cell');
            polygon.setAttribute('data-hex-id', `${q},${r}`);
            polygon.dataset.color = fill.toUpperCase();
            
            // Store color data for touch handling
            polygon.dataset.q = q;
            polygon.dataset.r = r;
            polygon.dataset.color = fill;
            
            // Desktop click handler
            polygon.addEventListener('click', (e) => {
                e.stopPropagation();
                saveState();
                
                // Update HSV state from axial coordinates
                pickerHue = hueFromAxial(q, r);
                pickerSat = satFromAxial(q, r, HEX_RADIUS);
                // Keep current brightness value
                
                // Generate color with current brightness
                const newColor = hsvToHex(pickerHue, pickerSat, pickerVal).toUpperCase();
                applyColor(newColor);
                updateBrightnessSliderGradient();
            });
            
            svg.appendChild(polygon);
        });
        
        // Mobile Touch Variables
        let isDragging = false;
        let activePolygon = null;
        
        // Helper: Get polygon at touch point
        function getPolygonAtPoint(x, y) {
            magnifier.style.pointerEvents = 'none';
            const element = document.elementFromPoint(x, y);
            magnifier.style.pointerEvents = 'auto';
            
            if (element && element.tagName === 'polygon' && element.classList.contains('hex-cell') && element.dataset.color) {
                return element;
            }
            return null;
        }
        
        // Helper: Update magnifier position and color
        function updateMagnifier(x, y, color) {
            magnifier.style.left = x + 'px';
            magnifier.style.top = (y - 100) + 'px'; // Position above finger
            magnifier.style.backgroundColor = color;
            magnifier.textContent = color;
            
            // Adjust text color for contrast
            const rgb = parseInt(color.slice(1), 16);
            const r = (rgb >> 16) & 0xff;
            const g = (rgb >> 8) & 0xff;
            const b = rgb & 0xff;
            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            magnifier.style.color = brightness > 128 ? '#000' : '#fff';
        }
        
        // Helper: Set active hexagon
        function setActiveHex(polygon) {
            // Remove active state from all hexes
            svg.querySelectorAll('polygon.hex-cell').forEach(p => {
                p.classList.remove('active-hex');
            });
            
            if (polygon) {
                polygon.classList.add('active-hex');
                activePolygon = polygon;
            } else {
                activePolygon = null;
            }
        }
        
        // Helper: Select color
        function selectColorFromPolygon(polygon) {
            if (!polygon) return;
            
            saveState();
            const q = parseInt(polygon.dataset.q);
            const r = parseInt(polygon.dataset.r);
            
            pickerHue = hueFromAxial(q, r);
            pickerSat = satFromAxial(q, r, HEX_RADIUS);
            const newColor = hsvToHex(pickerHue, pickerSat, pickerVal).toUpperCase();
            applyColor(newColor);
            updateBrightnessSliderGradient();
            
            console.log('✅ Color selected:', newColor);
        }
        
        // MOBILE: Touch Start - Show Magnifier
        svg.addEventListener('touchstart', (e) => {
            e.preventDefault();
            isDragging = true;
            const touch = e.touches[0];
            const polygon = getPolygonAtPoint(touch.clientX, touch.clientY);
            
            if (polygon && polygon.dataset.color) {
                const color = polygon.dataset.color;
                setActiveHex(polygon);
                updateMagnifier(touch.clientX, touch.clientY, color);
                magnifier.classList.add('visible');
            }
        }, { passive: false });
        
        // MOBILE: Touch Move - Drag to Preview Colors
        svg.addEventListener('touchmove', (e) => {
            e.preventDefault();
            if (!isDragging) return;
            
            const touch = e.touches[0];
            const polygon = getPolygonAtPoint(touch.clientX, touch.clientY);
            
            if (polygon && polygon.dataset.color) {
                const color = polygon.dataset.color;
                setActiveHex(polygon);
                updateMagnifier(touch.clientX, touch.clientY, color);
            }
        }, { passive: false });
        
        // MOBILE: Touch End - Select Color
        svg.addEventListener('touchend', (e) => {
            e.preventDefault();
            isDragging = false;
            magnifier.classList.remove('visible');
            
            if (activePolygon) {
                selectColorFromPolygon(activePolygon);
            }
            
            setTimeout(() => setActiveHex(null), 200);
        }, { passive: false });
        
        // MOBILE: Touch Cancel
        svg.addEventListener('touchcancel', () => {
            isDragging = false;
            magnifier.classList.remove('visible');
            setTimeout(() => setActiveHex(null), 200);
        });
        
        // Set initial selection
        updateSVGHexSelection(currentColor);
        updateBrightnessSliderGradient();
        
        // Brightness slider handler with smooth animation
        if (brightnessSlider) {
            brightnessSlider.addEventListener('input', (e) => {
                saveState();
                pickerVal = Number(e.target.value) / 100;
                const newColor = hsvToHex(pickerHue, pickerSat, pickerVal).toUpperCase();
                applyColor(newColor, true); // Skip recent colors for slider (too many updates)
            });

            // Keyboard support: Arrow keys adjust brightness
            brightnessSlider.addEventListener('keydown', (e) => {
                let step = 5;
                if (e.shiftKey) step = 1; // Fine adjustment with Shift
                
                if (e.key === 'ArrowUp' || e.key === 'ArrowRight') {
                    e.preventDefault();
                    const newValue = Math.min(100, Number(brightnessSlider.value) + step);
                    brightnessSlider.value = newValue;
                    brightnessSlider.dispatchEvent(new Event('input', { bubbles: true }));
                } else if (e.key === 'ArrowDown' || e.key === 'ArrowLeft') {
                    e.preventDefault();
                    const newValue = Math.max(0, Number(brightnessSlider.value) - step);
                    brightnessSlider.value = newValue;
                    brightnessSlider.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
        }
    }
    
    // Update selection state in SVG hexagonal grid
    function updateSVGHexSelection(selectedColor) {
        const svg = document.getElementById(`hexSvg-${sectionId}`);
        if (!svg) return;
        
        const polygons = svg.querySelectorAll('polygon.hex-cell');
        let foundMatch = false;
        
        polygons.forEach(polygon => {
            // Remove all selection states
            polygon.classList.remove('selected', 'active-hex');
            
            // Check if this hex matches the selected color (accounting for brightness)
            if (polygon.dataset.color) {
                const baseColor = polygon.dataset.color.toUpperCase();
                // For exact match, select it
                if (baseColor === selectedColor.toUpperCase()) {
                    polygon.classList.add('selected');
                    foundMatch = true;
                }
            }
        });
        
        // If no exact match found, try to find closest match by comparing base colors
        if (!foundMatch) {
            // This handles cases where brightness slider changes the color
            // We'll select based on the closest hue/saturation match
            const selectedRgb = hexToRgb(selectedColor);
            if (selectedRgb) {
                let closestPolygon = null;
                let minDistance = Infinity;
                
                polygons.forEach(polygon => {
                    if (polygon.dataset.color) {
                        const baseRgb = hexToRgb(polygon.dataset.color);
                        if (baseRgb) {
                            // Calculate color distance (simple Euclidean in RGB)
                            const distance = Math.sqrt(
                                Math.pow(selectedRgb.r - baseRgb.r, 2) +
                                Math.pow(selectedRgb.g - baseRgb.g, 2) +
                                Math.pow(selectedRgb.b - baseRgb.b, 2)
                            );
                            if (distance < minDistance) {
                                minDistance = distance;
                                closestPolygon = polygon;
                            }
                        }
                    }
                });
                
                if (closestPolygon && minDistance < 50) {  // Threshold for "close enough"
                    closestPolygon.classList.add('selected');
                }
            }
        }
    }
    
    // Helper: Convert hex to RGB
    function hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    
    // Initialize the SVG hexagonal picker on load
    initSVGHexagonalPicker();

    // Initialize recent colors and contrast display
    if (recentSwatches) {
        renderRecentColors();
    }
    
    // Initialize contrast display with current color
    if (contrastInfo) {
        updateContrastDisplay(currentColor);
    }

    // Save state for undo
    function saveState() {
        const state = {
            text: textInput.value,
            color: currentColor,
            font: currentFont,
            fontSize: currentFontSize,
            size: sizeSlider.value,
            rotation: rotateSlider.value,
            flipH: flipH,
            flipV: flipV,
            inverted: inverted,
            left: designOverlay.style.left,
            top: designOverlay.style.top
        };
        
        undoHistory.push(state);
        if (undoHistory.length > MAX_UNDO) {
            undoHistory.shift();
        }
        
        undoBtn.disabled = undoHistory.length === 0;
    }

    // Undo last action
    undoBtn.addEventListener('click', () => {
        if (undoHistory.length > 0) {
            const state = undoHistory.pop();
            
            textInput.value = state.text;
            designText.textContent = state.text || 'YOUR DESIGN HERE';
            applyColor(state.color, true); // Skip recent colors on undo/redo
            currentFont = state.font;
            designText.style.fontFamily = state.font;
            if (state.fontSize) {
                updateFontSize(state.fontSize);
            }
            sizeSlider.value = state.size;
            sizeValue.textContent = `${state.size}%`;
            rotateSlider.value = state.rotation;
            rotateValue.textContent = `${state.rotation}°`;
            flipH = state.flipH;
            flipV = state.flipV;
            inverted = state.inverted;
            designOverlay.style.left = state.left;
            designOverlay.style.top = state.top;
            
            updateTransform();
            updateFlipButtons();
            updateColorSwatches();
            
            undoBtn.disabled = undoHistory.length === 0;
        }
    });

    // Placement guide toggle
    guideBtn.addEventListener('click', () => {
        guideActive = !guideActive;
        if (guideActive) {
            placementGuide.classList.add('active');
            guideBtn.textContent = '✓ Guide On';
            guideBtn.style.background = 'rgba(96, 165, 250, 0.2)';
            guideBtn.style.borderColor = '#60a5fa';
        } else {
            placementGuide.classList.remove('active');
            guideBtn.textContent = '📐 Placement Guide';
            guideBtn.style.background = 'rgba(255, 255, 255, 0.1)';
            guideBtn.style.borderColor = 'rgba(255, 255, 255, 0.2)';
        }
    });

    // ============================================
    // PRINT AREA ADJUSTMENT PANEL
    // ============================================
    const adjustBtn = document.getElementById(`adjustBtn-${sectionId}`);
    const adjustPanel = document.getElementById(`adjustPanel-${sectionId}`);
    const closeAdjustBtn = document.getElementById(`closeAdjustBtn-${sectionId}`);
    const printWidthSlider = document.getElementById(`printWidth-${sectionId}`);
    const printHeightSlider = document.getElementById(`printHeight-${sectionId}`);
    const printTopSlider = document.getElementById(`printTop-${sectionId}`);
    const printWidthValue = document.getElementById(`printWidthValue-${sectionId}`);
    const printHeightValue = document.getElementById(`printHeightValue-${sectionId}`);
    const printTopValue = document.getElementById(`printTopValue-${sectionId}`);
    const displayWidth = document.getElementById(`displayWidth-${sectionId}`);
    const displayHeight = document.getElementById(`displayHeight-${sectionId}`);
    const displayTop = document.getElementById(`displayTop-${sectionId}`);
    const resetPrintBtn = document.getElementById(`resetPrintBtn-${sectionId}`);
    const copyPrintBtn = document.getElementById(`copyPrintBtn-${sectionId}`);

    console.log('🎯 Print Area Adjustment Panel initialized:', {
        adjustBtn: !!adjustBtn,
        adjustPanel: !!adjustPanel,
        sliders: !!(printWidthSlider && printHeightSlider && printTopSlider)
    });

    // Toggle adjustment panel
    adjustBtn.addEventListener('click', () => {
        const isVisible = adjustPanel.style.display !== 'none';
        adjustPanel.style.display = isVisible ? 'none' : 'block';
        console.log('🎯 Adjustment panel toggled:', !isVisible ? 'shown' : 'hidden');
        if (!isVisible) {
            adjustBtn.textContent = '✓ Adjusting';
            adjustBtn.style.background = 'rgba(96, 165, 250, 0.2)';
            adjustBtn.style.borderColor = '#60a5fa';
        } else {
            adjustBtn.textContent = '🎯 Adjust Print Area';
            adjustBtn.style.background = 'rgba(255, 255, 255, 0.1)';
            adjustBtn.style.borderColor = 'rgba(255, 255, 255, 0.2)';
        }
    });

    closeAdjustBtn.addEventListener('click', () => {
        adjustPanel.style.display = 'none';
        adjustBtn.textContent = '🎯 Adjust Print Area';
        adjustBtn.style.background = 'rgba(255, 255, 255, 0.1)';
        adjustBtn.style.borderColor = 'rgba(255, 255, 255, 0.2)';
    });

    // Function to update print area dimensions
    function updatePrintAreaDimensions() {
        const width = parseFloat(printWidthSlider.value).toFixed(1);
        const height = parseFloat(printHeightSlider.value).toFixed(1);
        const top = parseFloat(printTopSlider.value).toFixed(1);

        // Update slider display values
        printWidthValue.textContent = width;
        printHeightValue.textContent = height;
        printTopValue.textContent = top;

        // Update prominent display values
        displayWidth.textContent = `${width}%`;
        displayHeight.textContent = `${height}%`;
        displayTop.textContent = `${top}%`;

        // Create or update dynamic style
        let styleEl = document.getElementById(`printAreaDynamicStyle-${sectionId}`);
        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = `printAreaDynamicStyle-${sectionId}`;
            document.head.appendChild(styleEl);
        }

        styleEl.textContent = `
            .cts-design-overlay-${sectionId} {
                width: ${width}% !important;
                height: ${height}% !important;
                top: ${top}% !important;
            }
            .cts-placement-guide-${sectionId} {
                width: ${width}% !important;
                height: ${height}% !important;
                top: ${top}% !important;
            }
        `;

        console.log(`🎯 Print area updated: Width=${width}%, Height=${height}%, Top=${top}%`);
    }

    // Slider event listeners
    printWidthSlider.addEventListener('input', updatePrintAreaDimensions);
    printHeightSlider.addEventListener('input', updatePrintAreaDimensions);
    printTopSlider.addEventListener('input', updatePrintAreaDimensions);

    // Reset button
    resetPrintBtn.addEventListener('click', () => {
        printWidthSlider.value = 37;
        printHeightSlider.value = 42;
        printTopSlider.value = 29;
        updatePrintAreaDimensions();
    });

    // Copy CSS button
    copyPrintBtn.addEventListener('click', () => {
        const width = printWidthSlider.value;
        const height = printHeightSlider.value;
        const top = printTopSlider.value;

        const cssCode = `.cts-design-overlay-${sectionId} {
    position: absolute;
    width: ${width}%;
    height: ${height}%;
    left: 50%;
    top: ${top}%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: move;
    transition: all 0.2s ease;
}

.cts-placement-guide-${sectionId} {
    position: absolute;
    width: ${width}%;
    height: ${height}%;
    left: 50%;
    top: ${top}%;
    transform: translateX(-50%);
    border: 2px dashed rgba(96, 165, 250, 0.6);
    background: rgba(96, 165, 250, 0.1);
    pointer-events: none;
    display: none;
    z-index: 10;
}`;

        // Copy to clipboard
        navigator.clipboard.writeText(cssCode).then(() => {
            const originalText = copyPrintBtn.textContent;
            copyPrintBtn.textContent = '✓ Copied!';
            copyPrintBtn.style.background = 'rgba(34, 197, 94, 0.3)';
            copyPrintBtn.style.borderColor = '#22c55e';
            copyPrintBtn.style.color = '#22c55e';
            
            setTimeout(() => {
                copyPrintBtn.textContent = originalText;
                copyPrintBtn.style.background = 'rgba(96, 165, 250, 0.2)';
                copyPrintBtn.style.borderColor = '#60a5fa';
                copyPrintBtn.style.color = '#60a5fa';
            }, 2000);
        }).catch(err => {
            console.error('Failed to copy CSS:', err);
            alert('Failed to copy. Please copy manually from console.');
            console.log(cssCode);
        });
    });

    // T-Shirt color toggle with keyboard support
    document.querySelectorAll(`.cts-tshirt-color-option-${sectionId}`).forEach(btn => {
        const handleSelect = () => {
            document.querySelectorAll(`.cts-tshirt-color-option-${sectionId}`).forEach(b => {
                b.classList.remove('active');
                b.setAttribute('aria-pressed', 'false');
            });
            btn.classList.add('active');
            btn.setAttribute('aria-pressed', 'true');
            
            tshirtColor = btn.dataset.color;
            
            // Update t-shirt image - use actual black t-shirt mockup
            if (tshirtColor === 'black') {
                tshirtImage.src = studioElement && studioElement.dataset.assetTshirtBlack ? studioElement.dataset.assetTshirtBlack : '/assets/tshirt-black-v2.png';
                tshirtImage.style.filter = 'none';
                
                // Adjust text color for visibility on black shirt
                if (currentColor === '#000000') {
                    applyColor('#ffffff', true);
                    updateColorSwatches();
                }
            } else {
                tshirtImage.src = studioElement && studioElement.dataset.assetTshirtView ? studioElement.dataset.assetTshirtView : '/assets/tshirt-view.png';
                tshirtImage.style.filter = 'none';
            }
        };
        
        btn.addEventListener('click', handleSelect);
        
        // Keyboard support
        btn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleSelect();
            }
        });
    });
      
    // Text input with boundary control
    textInput.addEventListener('input', (e) => {
        if (!uploadedImage) {
            saveState();
            designText.textContent = e.target.value || 'YOUR DESIGN HERE';
            checkBoundary();
        }
    });

    // Normalize hex color input (handles paste with or without #)
    function normalizeHexColor(input) {
        let hex = input.trim().toUpperCase();
        
        // Remove # if present, then add it back
        hex = hex.replace(/^#/, '');
        
        // Validate hex characters (0-9, A-F)
        if (!/^[0-9A-F]{3,6}$/i.test(hex)) {
            return null;
        }
        
        // Convert short format (3 chars) to long format (6 chars)
        if (hex.length === 3) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        
        // Ensure 6 characters
        if (hex.length !== 6) {
            return null;
        }
        
        return '#' + hex;
    }

    // Hex color input with paste support and Enter key
    hexInput.addEventListener('input', (e) => {
        let hex = e.target.value.trim();
        
        // Normalize the hex color (accepts RRGGBB or #RRGGBB)
        const normalizedHex = normalizeHexColor(hex);
        
        if (normalizedHex) {
            e.target.value = normalizedHex;
            
            // Update color if valid
            if (/^#([0-9A-F]{6})$/i.test(normalizedHex)) {
                applyColor(normalizedHex);
                e.target.classList.remove('invalid');
            }
        } else if (hex.length > 0) {
            // Show invalid state for non-empty invalid input
            e.target.classList.add('invalid');
        } else {
            e.target.classList.remove('invalid');
        }
    });

    // Enter key applies color
    hexInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const normalizedHex = normalizeHexColor(hexInput.value);
            if (normalizedHex && /^#([0-9A-F]{6})$/i.test(normalizedHex)) {
                applyColor(normalizedHex);
                hexInput.blur();
            }
        }
    });

    // Handle paste event for better paste normalization
    hexInput.addEventListener('paste', (e) => {
        e.preventDefault();
        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
        const normalizedHex = normalizeHexColor(pastedText);
        
        if (normalizedHex) {
            hexInput.value = normalizedHex;
            hexInput.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
            // Show brief invalid feedback
            hexInput.classList.add('invalid');
            setTimeout(() => {
                hexInput.classList.remove('invalid');
            }, 1000);
        }
    });

    // ============================================
    // RECENT COLORS STORAGE & DISPLAY
    // ============================================
    const RECENT_COLORS_KEY = `cts-recent-colors-${sectionId}`;
    const MAX_RECENT_COLORS = 8;

    // Get recent colors from localStorage
    function getRecentColors() {
        try {
            const stored = localStorage.getItem(RECENT_COLORS_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch (e) {
            return [];
        }
    }

    // Save color to recent colors (dedupe, most recent first)
    function saveToRecentColors(color) {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) return;
        
        let recent = getRecentColors();
        // Remove if already exists
        recent = recent.filter(c => c.toUpperCase() !== color.toUpperCase());
        // Add to front
        recent.unshift(color.toUpperCase());
        // Keep only MAX_RECENT_COLORS
        recent = recent.slice(0, MAX_RECENT_COLORS);
        
        try {
            localStorage.setItem(RECENT_COLORS_KEY, JSON.stringify(recent));
            renderRecentColors();
        } catch (e) {
            console.warn('Failed to save recent colors:', e);
        }
    }

    // Render recent color swatches
    function renderRecentColors() {
        if (!recentSwatches) return;
        
        const recent = getRecentColors();
        recentSwatches.innerHTML = '';
        
        recent.forEach(color => {
            const swatch = document.createElement('button');
            swatch.className = `cts-recent-swatch-${sectionId}`;
            swatch.style.background = color;
            swatch.setAttribute('aria-label', `Select color ${color}`);
            swatch.setAttribute('title', color);
            
            swatch.addEventListener('click', () => {
                applyColor(color);
            });
            
            recentSwatches.appendChild(swatch);
        });
    }

    // ============================================
    // CONTRAST CALCULATION
    // ============================================
    // Calculate relative luminance (WCAG)
    function getLuminance(hex) {
        const rgb = hexToRgb(hex);
        if (!rgb) return 0;
        
        const [r, g, b] = [rgb.r / 255, rgb.g / 255, rgb.b / 255].map(val => {
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        });
        
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    }

    // Calculate contrast ratio between two colors
    function getContrastRatio(color1, color2) {
        const lum1 = getLuminance(color1);
        const lum2 = getLuminance(color2);
        const lighter = Math.max(lum1, lum2);
        const darker = Math.min(lum1, lum2);
        return (lighter + 0.05) / (darker + 0.05);
    }

    // Update contrast display
    function updateContrastDisplay(color) {
        if (!contrastInfo || !contrastWhite || !contrastBlack) return;
        
        const whiteContrast = getContrastRatio(color, '#FFFFFF');
        const blackContrast = getContrastRatio(color, '#000000');
        
        contrastWhite.textContent = whiteContrast.toFixed(2);
        contrastBlack.textContent = blackContrast.toFixed(2);
        
        // Show warning if contrast is low (< 4.5 for normal text, < 3 for large text)
        const minContrast = Math.max(whiteContrast, blackContrast);
        if (minContrast < 3) {
            contrastWarning.style.display = 'inline-block';
        } else {
            contrastWarning.style.display = 'none';
        }
    }

    // ============================================
    // APPLY COLOR (with pulse animation)
    // ============================================
    function applyColor(color, skipRecent = false) {
        if (!/^#[0-9A-F]{6}$/i.test(color)) return;
        
        saveState();
        currentColor = color.toUpperCase();
        designText.style.color = currentColor;
        hexInput.value = currentColor;
        hexPreview.style.background = currentColor;
        updateSVGHexSelection(currentColor);
        updateContrastDisplay(currentColor);
        
        if (!skipRecent) {
            saveToRecentColors(currentColor);
        }
        
        // Pulse animation on preview swatch
        if (hexPreview) {
            hexPreview.classList.add('pulse');
            setTimeout(() => {
                hexPreview.classList.remove('pulse');
            }, 300);
        }
    }

    // Copy hex color to clipboard with enhanced feedback
    if (hexCopyBtn) {
        hexCopyBtn.addEventListener('click', async () => {
            try {
                const hexValue = hexInput.value || currentColor;
                await navigator.clipboard.writeText(hexValue);
                
                // Enhanced visual feedback
                hexCopyBtn.classList.add('copied');
                const originalHTML = hexCopyBtn.innerHTML;
                hexCopyBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6667 3.5L5.25 9.91667L2.33333 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                
                setTimeout(() => {
                    hexCopyBtn.classList.remove('copied');
                    hexCopyBtn.innerHTML = originalHTML;
                }, 1500);
            } catch (err) {
                console.error('Failed to copy hex color:', err);
                // Fallback for older browsers
                hexInput.select();
                document.execCommand('copy');
            }
        });
    }

    // Click preview swatch to focus hex input (optional enhancement)
    if (hexPreview) {
        hexPreview.addEventListener('click', () => {
            hexInput.focus();
            hexInput.select();
        });
        
        // Keyboard accessibility
        hexPreview.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                hexInput.focus();
                hexInput.select();
            }
        });
    }

    // Update color swatches to show active state
    function updateColorSwatches() {
        document.querySelectorAll(`.cts-color-option-${sectionId}`).forEach(option => {
            if (option.dataset.color.toLowerCase() === currentColor.toLowerCase()) {
                option.classList.add('active');
            } else {
                option.classList.remove('active');
            }
        });
    }

    // Font selector with search and filtering
    const fontSelector = document.getElementById(`fontSelector-${sectionId}`);
    const fontOptions = document.querySelectorAll(`.cts-font-option-${sectionId}`);
    const fontSearch = document.getElementById(`fontSearch-${sectionId}`);
    const categoryButtons = document.querySelectorAll(`.cts-font-category-${sectionId}`);
    
    let currentCategory = 'all';
    let currentSearch = '';
    
    // Font Selection
    fontOptions.forEach(option => {
        option.addEventListener('click', function() {
            saveState();
            // Remove active class from all
            fontOptions.forEach(opt => opt.classList.remove('active'));
            
            // Add active class to clicked option
            this.classList.add('active');
            
            // Get font family and apply it
            currentFont = this.getAttribute('data-font');
            designText.style.fontFamily = currentFont;
        });
    });
    
    // Search Functionality
    if (fontSearch) {
        fontSearch.addEventListener('input', function() {
            currentSearch = this.value.toLowerCase().trim();
            filterFonts();
        });
    }
    
    // Category Filtering
    categoryButtons.forEach(button => {
        button.addEventListener('click', function() {
            saveState();
            // Update active category button
            categoryButtons.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');
            
            // Update current category
            currentCategory = this.getAttribute('data-category');
            filterFonts();
        });
    });
    
    // Combined Filter Function
    function filterFonts() {
        let visibleCount = 0;
        
        fontOptions.forEach(option => {
            const fontName = option.getAttribute('data-name');
            const fontCategory = option.getAttribute('data-category');
            
            // Check if matches search
            const matchesSearch = currentSearch === '' || fontName.includes(currentSearch);
            
            // Check if matches category
            const matchesCategory = currentCategory === 'all' || fontCategory === currentCategory;
            
            // Show or hide based on both filters
            if (matchesSearch && matchesCategory) {
                option.classList.remove('hidden');
                visibleCount++;
            } else {
                option.classList.add('hidden');
            }
        });
        
        // Show "no results" message if needed
        showNoResults(visibleCount === 0);
    }
    
    function showNoResults(show) {
        if (!fontSelector) return;
        
        let noResultsMsg = fontSelector.querySelector(`.cts-font-no-results-${sectionId}`);
        
        if (show && !noResultsMsg) {
            noResultsMsg = document.createElement('div');
            noResultsMsg.className = `cts-font-no-results-${sectionId}`;
            noResultsMsg.textContent = 'No fonts found. Try a different search or category.';
            fontSelector.appendChild(noResultsMsg);
        } else if (!show && noResultsMsg) {
            noResultsMsg.remove();
        }
    }

    // Color selector
    document.querySelectorAll(`.cts-color-option-${sectionId}`).forEach(option => {
        option.addEventListener('click', () => {
            saveState();
            document.querySelectorAll(`.cts-color-option-${sectionId}`).forEach(o => o.classList.remove('active'));
            option.classList.add('active');
            currentColor = option.dataset.color;
            designText.style.color = currentColor;
            hexInput.value = currentColor;
            hexPreview.style.background = currentColor;
        });
    });

    // Flip Horizontal
    flipHBtn.addEventListener('click', () => {
        saveState();
        flipH = !flipH;
        updateTransform();
        updateFlipButtons();
    });

    // Flip Vertical
    flipVBtn.addEventListener('click', () => {
        saveState();
        flipV = !flipV;
        updateTransform();
        updateFlipButtons();
    });

    // Update flip button states
    function updateFlipButtons() {
        flipHBtn.classList.toggle('active', flipH);
        flipVBtn.classList.toggle('active', flipV);
    }

    // Invert colors
    invertBtn.addEventListener('click', () => {
        saveState();
        inverted = !inverted;
        invertBtn.classList.toggle('active', inverted);
        
        if (inverted) {
            designText.style.filter = 'invert(1) hue-rotate(180deg)';
            if (uploadedImage) {
                uploadedImage.style.filter = 'invert(1) hue-rotate(180deg)';
            }
        } else {
            designText.style.filter = 'none';
            if (uploadedImage) {
                uploadedImage.style.filter = 'none';
            }
        }
    });

    // Image upload
    imageUpload.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validate file type
            const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp', 'image/svg+xml'];
            const isValidType = validTypes.includes(file.type.toLowerCase());
            
            if (!isValidType) {
                alert('❌ Invalid file format!\n\nSupported formats:\n✅ PNG (.png)\n✅ JPG/JPEG (.jpg, .jpeg)\n✅ GIF (.gif)\n✅ WebP (.webp)\n✅ SVG (.svg)');
                imageUpload.value = ''; // Clear the input
        return;
      }
      
            // Validate file size (max 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (file.size > maxSize) {
                alert('❌ File too large!\n\nMaximum file size: 10MB\nYour file: ' + (file.size / 1024 / 1024).toFixed(2) + 'MB');
                imageUpload.value = ''; // Clear the input
        return;
      }
      
            console.log('✅ Valid image uploaded:', file.name, file.type, (file.size / 1024).toFixed(2) + 'KB');
      
            saveState();
      const reader = new FileReader();
            reader.onload = (event) => {
                if (uploadedImage) {
                    uploadedImage.remove();
                }
                
                uploadedImage = document.createElement('img');
                uploadedImage.className = `cts-design-image-${sectionId}`;
                uploadedImage.src = event.target.result;
                
                if (inverted) {
                    uploadedImage.style.filter = 'invert(1) hue-rotate(180deg)';
                }
                
                designText.style.display = 'none';
                designOverlay.appendChild(uploadedImage);
            };
            reader.readAsDataURL(file);
        }
    });

    // Size slider
    sizeSlider.addEventListener('input', (e) => {
        sizeValue.textContent = `${e.target.value}%`;
        updateTransform();
    });

    sizeSlider.addEventListener('change', () => {
        saveState();
    });

    // Rotation slider
    rotateSlider.addEventListener('input', (e) => {
        rotateValue.textContent = `${e.target.value}°`;
        updateTransform();
    });

    rotateSlider.addEventListener('change', () => {
        saveState();
    });

    // ============================================
    // CANVAS ZOOM FUNCTIONALITY
    // ============================================
    
    // Store references
    const mockupStage = document.querySelector(`.cts-mockup-stage-${sectionId}`);
    const tshirtContainer = document.getElementById(`tshirtContainer-${sectionId}`);
    
    // Update canvas zoom - MOBILE-OPTIMIZED APPROACH
    function updateCanvasZoom() {
        const zoomLevel = canvasZoomSlider.value / 100;
        
        if (mockupCanvas && tshirtContainer && mockupStage) {
            // Update zoom display
            zoomValue.textContent = `${canvasZoomSlider.value}%`;
            
            // MOBILE FIX: Use CSS transform scale instead of changing dimensions
            // This prevents layout shifts and white space issues
            mockupStage.style.transform = `scale(${zoomLevel})`;
            mockupStage.style.transformOrigin = 'center center';
            
            // Make canvas scrollable when zoomed
            if (zoomLevel > 1) {
                mockupCanvas.style.overflow = 'auto';
                mockupCanvas.style.overscrollBehavior = 'contain';
                
                // Center the scrolled content
                setTimeout(() => {
                    mockupCanvas.scrollLeft = (mockupCanvas.scrollWidth - mockupCanvas.clientWidth) / 2;
                    mockupCanvas.scrollTop = (mockupCanvas.scrollHeight - mockupCanvas.clientHeight) / 2;
                }, 50);
      } else {
                mockupCanvas.style.overflow = 'hidden';
            }
            
            console.log(`🔍 Canvas zoom: ${canvasZoomSlider.value}% (using CSS transform: scale)`);
        }
    }
    
    // Canvas zoom slider
    if (canvasZoomSlider) {
        canvasZoomSlider.addEventListener('input', (e) => {
            updateCanvasZoom();
        });
        
        // MOBILE FIX: Prevent page scroll when using slider
        canvasZoomSlider.addEventListener('touchstart', (e) => {
            e.stopPropagation();
        }, { passive: true });
        
        canvasZoomSlider.addEventListener('touchmove', (e) => {
            e.stopPropagation();
        }, { passive: true });
    }
    
    // Zoom in button
    if (zoomInBtn) {
        zoomInBtn.addEventListener('click', () => {
            const currentZoom = parseInt(canvasZoomSlider.value);
            const newZoom = Math.min(200, currentZoom + 10);
            canvasZoomSlider.value = newZoom;
            updateCanvasZoom();
        });
        
        // MOBILE FIX: Prevent double-tap zoom
        zoomInBtn.addEventListener('touchend', (e) => {
            e.preventDefault();
            const currentZoom = parseInt(canvasZoomSlider.value);
            const newZoom = Math.min(200, currentZoom + 10);
            canvasZoomSlider.value = newZoom;
            updateCanvasZoom();
        });
    }
    
    // Zoom out button
    if (zoomOutBtn) {
        zoomOutBtn.addEventListener('click', () => {
            const currentZoom = parseInt(canvasZoomSlider.value);
            const newZoom = Math.max(50, currentZoom - 10);
            canvasZoomSlider.value = newZoom;
            updateCanvasZoom();
        });
        
        // MOBILE FIX: Prevent double-tap zoom
        zoomOutBtn.addEventListener('touchend', (e) => {
            e.preventDefault();
            const currentZoom = parseInt(canvasZoomSlider.value);
            const newZoom = Math.max(50, currentZoom - 10);
            canvasZoomSlider.value = newZoom;
            updateCanvasZoom();
        });
    }
    
    // Keyboard shortcuts for zoom (Ctrl/Cmd + Plus/Minus)
    document.addEventListener('keydown', (e) => {
        if ((e.ctrlKey || e.metaKey) && !e.shiftKey) {
            if (e.key === '=' || e.key === '+') {
                e.preventDefault();
                zoomInBtn.click();
            } else if (e.key === '-' || e.key === '_') {
                e.preventDefault();
                zoomOutBtn.click();
            } else if (e.key === '0') {
                e.preventDefault();
                canvasZoomSlider.value = 100;
                updateCanvasZoom();
            }
        }
    });
    
    // Mouse wheel zoom (Ctrl + Scroll)
    if (mockupCanvas) {
        mockupCanvas.addEventListener('wheel', (e) => {
            if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
                
                const currentZoom = parseInt(canvasZoomSlider.value);
                const delta = e.deltaY > 0 ? -5 : 5;
                const newZoom = Math.max(50, Math.min(200, currentZoom + delta));
                
                canvasZoomSlider.value = newZoom;
                updateCanvasZoom();
            }
        }, { passive: false });
    }

    function updateTransform() {
        const scale = sizeSlider.value / 100;
        const rotate = rotateSlider.value;
        const scaleX = flipH ? -1 : 1;
        const scaleY = flipV ? -1 : 1;
        
        designOverlay.style.transform = `translateX(-50%) scale(${scale * scaleX}, ${scale * scaleY}) rotate(${rotate}deg)`;
        checkBoundary();
    }

    // Check if design stays within boundary
    function checkBoundary() {
        const overlay = designOverlay.getBoundingClientRect();
        const container = designOverlay.parentElement.getBoundingClientRect();
        
        // Print area boundaries - different for back view
        let printWidth, printHeight, topOffset, horizontalOffset;
        
        if (currentView === 'back') {
            // Back view: 37.5% width, 42.9% height, top at 23.9%
            printWidth = 0.375;
            printHeight = 0.429;
            topOffset = 0.239;
            horizontalOffset = (1 - printWidth) / 2; // (1 - 0.375) / 2 = 0.3125
        } else {
            // Front view and others: 37% width, 42% height, top at 29%
            printWidth = 0.37;
            printHeight = 0.42;
            topOffset = 0.29;
            horizontalOffset = 0.315; // (1 - 0.37) / 2
        }
        
        const printAreaLeft = container.left + (container.width * horizontalOffset);
        const printAreaRight = container.right - (container.width * horizontalOffset);
        const printAreaTop = container.top + (container.height * topOffset);
        const printAreaBottom = printAreaTop + (container.height * printHeight);
        
        // Check if design is outside print area
        const isOutside = overlay.left < printAreaLeft || 
                         overlay.right > printAreaRight || 
                         overlay.top < printAreaTop || 
                         overlay.bottom > printAreaBottom;
        
        if (isOutside) {
            designOverlay.style.outline = '2px solid rgba(239, 68, 68, 0.8)';
          } else {
            designOverlay.style.outline = '';
        }
    }

    // Drag functionality with boundary constraints
    let isDragging = false;
    let startX, startY, startLeft, startTop;

    designOverlay.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
        startY = e.clientY;
        
        // Get current position from style or use defaults
        const currentLeft = parseFloat(designOverlay.style.left) || 50;
        const currentTop = parseFloat(designOverlay.style.top) || 29;
        
        startLeft = currentLeft;
        startTop = currentTop;
        designOverlay.style.cursor = 'grabbing';
    });

    document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        
        const parent = designOverlay.parentElement.getBoundingClientRect();
        const deltaX = ((e.clientX - startX) / parent.width) * 100;
        const deltaY = ((e.clientY - startY) / parent.height) * 100;
        
        let newLeft = startLeft + deltaX;
        let newTop = startTop + deltaY;
        
        // Constrain to safe area (with some margin) - different for back view
        const margin = 5;
        let minLeft, maxLeft, minTop, maxTop;
        
        if (currentView === 'back') {
            // Back view: 37.5% width, 42.9% height, starting at 23.9% top
            const horizontalOffset = (1 - 0.375) / 2 * 100; // 31.25%
            minLeft = horizontalOffset + margin; // 31.25 + 5 = 36.25
            maxLeft = (100 - horizontalOffset) - margin; // 68.75 - 5 = 63.75
            minTop = 23.9 + margin; // 28.9
            maxTop = 23.9 + 42.9 - margin; // 66.8 - 5 = 61.8
        } else {
            // Front view: 37% width, 42% height, starting at 29% top
            minLeft = 31.5 + margin; // 36.5
            maxLeft = 68.5 - margin; // 63.5
            minTop = 29 + margin; // 34
            maxTop = 71 - margin; // 66
        }
        
        newLeft = Math.max(minLeft, Math.min(maxLeft, newLeft));
        newTop = Math.max(minTop, Math.min(maxTop, newTop));
        
        designOverlay.style.left = `${newLeft}%`;
        designOverlay.style.top = `${newTop}%`;
        
        checkBoundary();
    });

    document.addEventListener('mouseup', () => {
        if (isDragging) {
            saveState();
            isDragging = false;
            designOverlay.style.cursor = 'move';
        }
    });

    // Reset button
    resetBtn.addEventListener('click', () => {
        saveState();
        
        textInput.value = 'YOUR DESIGN HERE';
        designText.textContent = 'YOUR DESIGN HERE';
        designText.style.display = 'block';
        designText.style.fontFamily = "'Bebas Neue', sans-serif";
        designText.style.color = '#000000';
        designText.style.filter = 'none';
        
        currentColor = '#000000';
        hexInput.value = '#000000';
        hexPreview.style.background = '#000000';
        currentFont = "'Bebas Neue', sans-serif";
        updateFontSize(32); // Reset font size to default
        
        // Reset font selection
        document.querySelectorAll(`.cts-font-option-${sectionId}`).forEach(o => o.classList.remove('active'));
        document.querySelector(`.cts-font-option-${sectionId}`).classList.add('active');
        
        // Reset font search and category
        if (fontSearch) {
            fontSearch.value = '';
            currentSearch = '';
        }
        currentCategory = 'all';
        categoryButtons.forEach(btn => btn.classList.remove('active'));
        if (categoryButtons.length > 0) {
            categoryButtons[0].classList.add('active'); // Activate "All" category
        }
        filterFonts(); // Apply filters to show all fonts
        
        updateColorSwatches();
        
        sizeSlider.value = 100;
        rotateSlider.value = 0;
        sizeValue.textContent = '100%';
        rotateValue.textContent = '0°';
        designOverlay.style.left = '50%';
        designOverlay.style.top = '29%';
        
        flipH = false;
        flipV = false;
        inverted = false;
        updateFlipButtons();
        invertBtn.classList.remove('active');
        
        if (uploadedImage) {
            uploadedImage.remove();
            uploadedImage = null;
        }
        
        imageUpload.value = '';
        updateTransform();
    });

    // Add to cart
    document.getElementById(`addToCartBtn-${sectionId}`).addEventListener('click', () => {
        alert('🎉 Design added to cart! (This is a demo)');
    });

    // Download preview
    // Download Preview
    document.getElementById(`downloadBtn-${sectionId}`).addEventListener('click', async () => {
        try {
            console.log('📥 Download button clicked');
            
            // Capture the current mockup
            const mockupDataUrl = await window.designerCaptureMockup();
            
            if (!mockupDataUrl) {
                alert('⚠️ Please create a design first!');
                return;
            }
            
            // Create download link
            const link = document.createElement('a');
            const timestamp = new Date().toISOString().slice(0, 10);
            link.download = `newthrifts-design-${timestamp}.png`;
            link.href = mockupDataUrl;
            link.click();
            
            console.log('✅ Design downloaded successfully!');
            
            // Show success feedback
            const btn = document.getElementById(`downloadBtn-${sectionId}`);
            const originalText = btn.textContent;
            btn.textContent = '✅ Downloaded!';
            btn.style.background = 'linear-gradient(135deg, #10b981, #059669)';
            
            setTimeout(() => {
                btn.textContent = originalText;
                btn.style.background = '';
            }, 2000);
      } catch (error) {
            console.error('❌ Download failed:', error);
            alert('⚠️ Unable to download. Please try again.');
        }
    });

    // Share design
    // Share Design
    document.getElementById(`shareBtn-${sectionId}`).addEventListener('click', async () => {
        try {
            console.log('🔗 Share button clicked');
            
            // Capture the current mockup
            const mockupDataUrl = await window.designerCaptureMockup();
            
            if (!mockupDataUrl) {
                alert('⚠️ Please create a design first!');
                return;
            }
            
            // Get design details
            const designText = textInput.value;
            const tshirtColorName = tshirtColor.charAt(0).toUpperCase() + tshirtColor.slice(1);
            
            // Create share data
            const shareTitle = 'Check out my custom T-shirt design!';
            const shareText = `I designed a custom ${tshirtColorName} t-shirt${designText && designText !== 'YOUR DESIGN HERE' ? ` with "${designText}"` : ''} on NewThrifts!`;
            
            // Check if Web Share API is available (mobile)
            if (navigator.share) {
                // Convert data URL to Blob for sharing
                const response = await fetch(mockupDataUrl);
                const blob = await response.blob();
                const file = new File([blob], 'my-tshirt-design.png', { type: 'image/png' });
                
                // Check if files can be shared
                if (navigator.canShare && navigator.canShare({ files: [file] })) {
                    await navigator.share({
                        title: shareTitle,
                        text: shareText,
                        files: [file]
                    });
                    console.log('✅ Design shared successfully!');
        } else {
                    // Share without file
                    await navigator.share({
                        title: shareTitle,
                        text: shareText,
                        url: window.location.href
                    });
                    console.log('✅ Link shared successfully!');
                }
            } else {
                // Fallback: Download the image
                const link = document.createElement('a');
                link.download = 'my-tshirt-design.png';
                link.href = mockupDataUrl;
                link.click();
                
                alert('✅ Design downloaded! You can now share the image file.');
            }
        } catch (error) {
            console.error('❌ Share failed:', error);
            
            // If share was cancelled, don't show error
            if (error.name === 'AbortError') {
                console.log('Share cancelled by user');
        return;
      }
            
            alert('⚠️ Unable to share. Try downloading the design instead!');
        }
    });

    // Initialize
    checkBoundary();
    
    // ============================================
    // INTEGRATION POINTS FOR ENHANCEMENTS
    // ============================================
    
    // Create a state object that enhancements can access
    const state = {
        layers: uploadedImage ? [{ type: 'image', src: uploadedImage.src, transform: { x: 50, y: 50 } }] : [],
        selectedLayerId: null,
        designText: textInput.value,
        fontSize: parseInt(sizeSlider.value),
        rotation: parseInt(rotateSlider.value),
        inverted: invertBtn.classList.contains('active'),
        flippedH: flipHBtn.classList.contains('active'),
        flippedV: flipVBtn.classList.contains('active')
    };
    
    // Expose functions for enhanced features to use
    window.designerGetState = function() {
        return {
            layers: window.designerGetLayers(), // Use the properly built layers
            designText: textInput.value,
            fontSize: parseInt(sizeSlider.value),
            rotation: parseInt(rotateSlider.value),
            currentColor: currentColor,
            currentFont: currentFont,
            tshirtColor: tshirtColor,
            uploadedImage: uploadedImage ? uploadedImage.src : null,
            inverted: invertBtn.classList.contains('active'),
            flippedH: flipHBtn.classList.contains('active'),
            flippedV: flipVBtn.classList.contains('active')
        };
    };
    
    window.designerLoadState = function(newState) {
        if (newState.layers) state.layers = newState.layers;
        if (newState.designText) textInput.value = newState.designText;
        if (newState.fontSize) sizeSlider.value = newState.fontSize;
        if (newState.rotation) rotateSlider.value = newState.rotation;
        updateTransform();
    };
    
    window.designerGetLayers = function() {
        // Build layers array from current design state
        const layers = [];
        
        // Add uploaded image layer if exists
        if (uploadedImage && uploadedImage.src) {
            layers.push({
                id: 'image-layer',
                type: 'image',
                src: uploadedImage.src,
                visible: true,
                transform: {
                    x: 50, // Center position
                    y: 50,
                    rotation: parseInt(rotateSlider.value) || 0,
                    scale: (parseInt(sizeSlider.value) || 100) / 100,
                    flipH: flipHBtn.classList.contains('active'),
                    flipV: flipVBtn.classList.contains('active')
                },
                filters: {
                    brightness: 100,
                    contrast: 100,
                    saturate: 100,
                    grayscale: 0,
                    sepia: 0,
                    blur: 0
                }
            });
        }
        
        // Add text layer if text exists
        if (textInput.value && textInput.value.trim() !== '' && textInput.value !== 'YOUR DESIGN HERE') {
            layers.push({
                id: 'text-layer',
                type: 'text',
                text: textInput.value,
                fontFamily: currentFont || 'Arial',
                fontSize: parseInt(sizeSlider.value) || 48,
                color: currentColor || '#000000',
                visible: true,
                letterSpacing: 0,
                align: 'center',
                textCase: 'none',
                stroke: { enabled: false },
                shadow: { enabled: false },
                transform: {
                    x: 50, // Center position
                    y: 50,
                    rotation: parseInt(rotateSlider.value) || 0,
                    scale: 1,
                    flipH: flipHBtn.classList.contains('active'),
                    flipV: flipVBtn.classList.contains('active')
                }
            });
        }
        
        return layers;
    };
    
    // Expose mockup capture function for exports
    window.designerCaptureMockup = captureMockupPreview;
    
    // Expose original design capture for exports
    window.designerCaptureOriginal = captureOriginalDesign;
    
    window.designerGetSelectedLayer = function() {
        return state.layers.find(l => l.id === state.selectedLayerId);
    };
    
    window.designerLoadTemplate = function(layers) {
        if (!Array.isArray(layers)) return;
        state.layers = layers;
        // Apply first text layer if exists
        const firstTextLayer = layers.find(l => l.type === 'text');
        if (firstTextLayer) {
            textInput.value = firstTextLayer.text || 'YOUR DESIGN HERE';
            designText.textContent = textInput.value;
            if (firstTextLayer.fontSize) sizeSlider.value = firstTextLayer.fontSize;
            if (firstTextLayer.transform && firstTextLayer.transform.rotation !== undefined) {
                rotateSlider.value = firstTextLayer.transform.rotation;
            }
            updateTransform();
        }
    };
    
    window.designerApplyGradient = function(gradient) {
        // Apply gradient to text using the Gradients enhancement
        if (window.DesignerEnhancements && window.DesignerEnhancements.Gradients) {
            window.DesignerEnhancements.Gradients.applyGradientToText(designText, gradient);
        }
    };
    
    // ============================================
    // SUBMIT REQUEST FUNCTIONALITY
    // ============================================
    
    const submitRequestBtn = document.getElementById(`submitRequestBtn-${sectionId}`);
    const customerInfoForm = document.getElementById(`customerInfoForm-${sectionId}`);
    const requestForm = document.getElementById(`requestForm-${sectionId}`);
    const cancelRequestBtn = document.getElementById(`cancelRequestBtn-${sectionId}`);
    const formStatus = document.getElementById(`formStatus-${sectionId}`);
    
    // Show customer info form when Submit Request is clicked
    if (submitRequestBtn && customerInfoForm) {
        submitRequestBtn.addEventListener('click', () => {
            customerInfoForm.style.display = 'block';
            customerInfoForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
    }
    
    // Hide form when Cancel is clicked
    if (cancelRequestBtn && customerInfoForm) {
        cancelRequestBtn.addEventListener('click', () => {
            customerInfoForm.style.display = 'none';
            requestForm.reset();
        });
    }
    
    // Function to capture JUST the original design (no t-shirt)
    async function captureOriginalDesign() {
        return new Promise((resolve) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const overlay = designOverlay;
            
            if (!overlay) {
                console.error('❌ Design overlay not found');
                resolve(null);
                return;
            }
            
            const overlayRect = overlay.getBoundingClientRect();
            const scale = 2; // 2x resolution for better quality
            canvas.width = overlayRect.width * scale;
            canvas.height = overlayRect.height * scale;
            
            // Scale context for high-res rendering
            ctx.scale(scale, scale);
            
            // Transparent background for original design
            ctx.clearRect(0, 0, overlayRect.width, overlayRect.height);
            
            // Save context state
            ctx.save();
            
            // Center the design
            ctx.translate(overlayRect.width / 2, overlayRect.height / 2);
            ctx.rotate((rotateSlider.value * Math.PI) / 180);
            
            // Draw text or image
            if (uploadedImage) {
                ctx.drawImage(uploadedImage, -overlayRect.width / 2, -overlayRect.height / 2, overlayRect.width, overlayRect.height);
            } else if (designText) {
                const fontSize = parseInt(window.getComputedStyle(designText).fontSize);
                ctx.font = `bold ${fontSize}px ${currentFont}`;
                ctx.fillStyle = currentColor;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(textInput.value, 0, 0);
            }
            
            ctx.restore();
            
            console.log('✅ Original design captured', `${canvas.width}x${canvas.height}`);
            
            // Convert to base64 with good quality
            resolve(canvas.toDataURL('image/png', 0.95));
        });
    }
    
    // Function to capture the mockup (t-shirt with design)
    async function captureMockupPreview() {
        return new Promise((resolve) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const mockupContainer = document.getElementById(`mockupCanvas-${sectionId}`);
            
            if (!mockupContainer) {
                console.error('❌ Mockup container not found:', `mockupCanvas-${sectionId}`);
                resolve(null);
                return;
            }
            
            console.log('✅ Mockup container found', mockupContainer);
            
            // Set canvas size to match the mockup container (higher resolution for email)
            const rect = mockupContainer.getBoundingClientRect();
            const scale = 2; // 2x resolution for better quality
            canvas.width = rect.width * scale;
            canvas.height = rect.height * scale;
            
            // Scale context for high-res rendering
            ctx.scale(scale, scale);
            
            // Draw white background
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, rect.width, rect.height);
            
            // Draw the t-shirt image
            const tshirtImg = tshirtImage;
            if (tshirtImg && tshirtImg.complete) {
                ctx.drawImage(tshirtImg, 0, 0, rect.width, rect.height);
            }
            
            // Draw the design overlay
            const overlay = designOverlay;
            if (overlay) {
                const overlayRect = overlay.getBoundingClientRect();
                const containerRect = mockupContainer.getBoundingClientRect();
                
                // Calculate position relative to container
                const x = overlayRect.left - containerRect.left;
                const y = overlayRect.top - containerRect.top;
                
                // Save context state
                ctx.save();
                
                // Apply transformations
                ctx.translate(x + overlayRect.width / 2, y + overlayRect.height / 2);
                ctx.rotate((rotateSlider.value * Math.PI) / 180);
                
                // Draw text or image
                if (uploadedImage) {
                    ctx.drawImage(uploadedImage, -overlayRect.width / 2, -overlayRect.height / 2, overlayRect.width, overlayRect.height);
                } else if (designText) {
                    const fontSize = parseInt(window.getComputedStyle(designText).fontSize);
                    ctx.font = `bold ${fontSize}px ${currentFont}`;
                    ctx.fillStyle = currentColor;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText(textInput.value, 0, 0);
                }
                
                ctx.restore();
            }
            
            console.log('✅ Mockup preview captured', `${canvas.width}x${canvas.height}`);
            
            // Convert to base64 with good quality
            resolve(canvas.toDataURL('image/png', 0.95));
        });
    }
    
    // Function to upload image to Supabase Storage (if available) or use base64
    async function uploadDesignImage(dataUrl) {
        // Check if Supabase is available
        if (window.NewThriftsCustomRequests && window.NewThriftsCustomRequests.uploadImageToStorage) {
            try {
                console.log('📤 Uploading design to Supabase Storage...');
                const imageUrl = await window.NewThriftsCustomRequests.uploadImageToStorage(
                    dataUrl, 
                    'mockup-previews'
                );
                console.log('✅ Image uploaded:', imageUrl);
                return imageUrl;
            } catch (error) {
                console.warn('⚠️ Supabase upload failed, using base64 fallback:', error);
                return dataUrl; // Fallback to base64
    }
  } else {
            console.log('ℹ️ Supabase not available, using base64 data');
            return dataUrl; // Use base64 if Supabase not available
        }
    }
    
    // Initialize EmailJS
    emailjs.init('p3BJ3t5_tiP_xTf5L');
    
    // Handle form submission
    if (requestForm) {
        requestForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            
            // Get form values
            const customerName = document.getElementById(`customerName-${sectionId}`).value;
            const customerEmail = document.getElementById(`customerEmail-${sectionId}`).value;
            const customerPhone = document.getElementById(`customerPhone-${sectionId}`).value || 'Not provided';
            const tshirtSizeValue = document.getElementById(`tshirtSize-${sectionId}`).value || 'Not specified';
            const customerMessage = document.getElementById(`customerMessage-${sectionId}`).value || 'No special instructions';
            
            // Validate required fields
            if (!customerName || !customerEmail) {
                alert('❌ Please fill in all required fields (Name and Email)');
      return;
    }
    
            // Show loading status
            formStatus.style.display = 'block';
            formStatus.style.background = 'linear-gradient(135deg, #3b82f6, #2563eb)';
            formStatus.style.color = 'white';
            formStatus.innerHTML = '⏳ Capturing your design and sending request...';
            
            try {
                // Capture BOTH images: original design and mockup
                console.log('📸 Capturing original design...');
                const originalDesignDataUrl = await captureOriginalDesign();
                
                console.log('📸 Capturing mockup preview...');
                const mockupPreviewDataUrl = await captureMockupPreview();
                
                if (!originalDesignDataUrl || !mockupPreviewDataUrl) {
                    throw new Error('Failed to capture design images');
                }
                
                // Upload both images to Supabase Storage (or use base64 fallback)
                console.log('📤 Uploading original design...');
                const originalDesignUrl = await uploadDesignImage(originalDesignDataUrl);
                
                console.log('📤 Uploading mockup preview...');
                const mockupPreviewUrl = await uploadDesignImage(mockupPreviewDataUrl);
                
                // Helper function to safely convert values to strings (from working code)
                const s = v => (v == null || v === "") ? "-" : String(v);
                
                // Ensure URLs are absolute HTTPS links (from working code)
                const ensureAbsoluteUrl = (url) => {
                    if (!url || url === '#') return '-';
                    if (url.startsWith('http://') || url.startsWith('https://')) return url;
                    // If relative URL, make it absolute (shouldn't happen, but just in case)
                    return url.startsWith('/') ? `https://newthrifts.com${url}` : url;
                };
                
                // Prepare email data with correct variable names matching EmailJS template
                const emailData = {
                    // Customer info
                    name: s(customerName),
                    email: s(customerEmail),
                    phone: s(customerPhone),
                    tshirt_size: s(tshirtSizeValue),
                    message: s(customerMessage),
                    
                    // Design specifications (matching template variables)
                    design_position: s('Center'),  // Placeholder - update if you track position
                    design_size: s(sizeSlider.value + '%'),
                    design_rotation: s(rotateSlider.value + '°'),
                    design_view: s('Front'),  // Placeholder - update if you track view
                    tshirt_color: s(tshirtColor),
                    
                    // Additional design details
                    design_text: s(textInput.value),
                    text_color: s(currentColor),
                    font_family: s(currentFont),
                    font_size: s(sizeSlider.value + '%'),
                    rotation: s(rotateSlider.value + '°'),
                    has_uploaded_image: uploadedImage ? 'Yes' : 'No',
                    
                // Metadata
                submission_date: s(new Date().toLocaleString()),
                request_id: s(`REQ-${Date.now().toString().slice(-8)}`),
                
                // Image URLs - SEPARATE IMAGES FOR ORIGINAL AND MOCKUP
                design_url: ensureAbsoluteUrl(originalDesignUrl),  // Just the design
                mockup_url: ensureAbsoluteUrl(mockupPreviewUrl),   // T-shirt with design
                logo_url: 'https://cdn.shopify.com/s/files/1/0644/9525/5650/files/NewThriftsLogo.svg?v=1760718145'
            };
            
            console.log('📧 Sending design request email...', emailData);
            console.log('🖼️ Image URLs (SEPARATE):');
            console.log('   🎨 Original Design:', emailData.design_url);
            console.log('   👕 Mockup Preview:', emailData.mockup_url);
                
                // Send email via EmailJS
                const result = await emailjs.send(
                    'service_f4r34d3',
                    'template_qiquke8',
                    emailData
                );
                
                console.log('✅ Email sent successfully:', result);
                
                // Show success message
                formStatus.style.background = 'linear-gradient(135deg, #10b981, #059669)';
                formStatus.innerHTML = `
                    ✅ <strong>Request Submitted Successfully!</strong><br>
                    <span style="font-size: 14px; font-weight: normal; opacity: 0.9;">
                        Thank you, ${customerName}! We've received your design and will contact you at ${customerEmail} shortly.
                    </span>
                `;
                
                // Reset form after 3 seconds
      setTimeout(() => {
                    requestForm.reset();
                    customerInfoForm.style.display = 'none';
                    formStatus.style.display = 'none';
                }, 5000);
                
            } catch (error) {
                console.error('❌ Email send failed:', error);
                
                // Show error message
                formStatus.style.background = 'linear-gradient(135deg, #ef4444, #dc2626)';
                formStatus.innerHTML = `
                    ❌ <strong>Submission Failed</strong><br>
                    <span style="font-size: 14px; font-weight: normal; opacity: 0.9;">
                        ${error.message || 'Please check your EmailJS configuration or try again later.'}
                    </span>
                `;
            }
        });
    }
    
    // ============================================
    // MOBILE TOUCH GESTURE SUPPORT
    // ============================================
    
    // Add touch gesture support for mobile devices
    let touchStartDistance = 0;
    let touchStartRotation = 0;
    let initialSize = 0;
    let initialRotation = 0;
    
    // Helper function to get distance between two touch points
    function getTouchDistance(touch1, touch2) {
        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }
    
    // Helper function to get angle between two touch points
    function getTouchAngle(touch1, touch2) {
        const dx = touch2.clientX - touch1.clientX;
        const dy = touch2.clientY - touch1.clientY;
        return Math.atan2(dy, dx) * 180 / Math.PI;
    }
    
    // Add pinch-to-zoom and rotate gestures on design overlay
    if (designOverlay) {
        designOverlay.addEventListener('touchstart', (e) => {
            if (e.touches.length === 2) {
                e.preventDefault();
                saveState();
                
                // Store initial values
                touchStartDistance = getTouchDistance(e.touches[0], e.touches[1]);
                touchStartRotation = getTouchAngle(e.touches[0], e.touches[1]);
                initialSize = parseInt(sizeSlider.value);
                initialRotation = parseInt(rotateSlider.value);
                
                console.log('📱 Touch gesture started - pinch/rotate enabled');
            }
        }, { passive: false });
        
        designOverlay.addEventListener('touchmove', (e) => {
            if (e.touches.length === 2) {
                e.preventDefault();
                
                // Calculate new distance and angle
                const currentDistance = getTouchDistance(e.touches[0], e.touches[1]);
                const currentAngle = getTouchAngle(e.touches[0], e.touches[1]);
                
                // Pinch to zoom (size)
                const scaleFactor = currentDistance / touchStartDistance;
                let newSize = Math.round(initialSize * scaleFactor);
                newSize = Math.max(10, Math.min(200, newSize)); // Clamp between 10-200%
                
                if (sizeSlider.value !== newSize.toString()) {
                    sizeSlider.value = newSize;
                    sizeValue.textContent = `${newSize}%`;
                    updateTransform();
                }
                
                // Rotate gesture
                const angleDiff = currentAngle - touchStartRotation;
                let newRotation = initialRotation + angleDiff;
                
                // Normalize rotation to -180 to 180
                while (newRotation > 180) newRotation -= 360;
                while (newRotation < -180) newRotation += 360;
                
                newRotation = Math.round(newRotation);
                
                if (rotateSlider.value !== newRotation.toString()) {
                    rotateSlider.value = newRotation;
                    rotateValue.textContent = `${newRotation}°`;
                    updateTransform();
                }
            }
        }, { passive: false });
        
        designOverlay.addEventListener('touchend', (e) => {
            if (e.touches.length < 2) {
                console.log('📱 Touch gesture ended');
            }
        });
    }
    
    // Prevent double-tap zoom on buttons (improves mobile UX)
    const buttons = document.querySelectorAll(`
        .cts-header-btn-${sectionId},
        .cts-transform-btn-${sectionId},
        .cts-tshirt-color-btn-${sectionId},
        .cts-action-btn-${sectionId},
        .cts-workflow-action-btn-${sectionId}
    `);
    
    buttons.forEach(button => {
        button.addEventListener('touchend', (e) => {
            e.preventDefault();
            button.click();
        });
    });
    
    // Add mobile-friendly scroll behavior
    if ('ontouchstart' in window) {
        console.log('📱 Mobile device detected - Touch optimizations enabled');
        
        // Smooth scroll for mobile
        document.querySelectorAll(`[id*="workflow-${sectionId}"]`).forEach(btn => {
            btn.addEventListener('click', () => {
                setTimeout(() => {
                    window.scrollTo({
                        top: window.scrollY + 100,
                        behavior: 'smooth'
                    });
                }, 100);
            });
        });
    }
    
    // ============================================
    // COLOR PALETTE HELPER MODAL
    // ============================================
    
    const colorPaletteHelperBtn = document.getElementById(`colorPaletteHelperBtn-${sectionId}`);
    const colorPaletteModal = document.getElementById(`colorPaletteModal-${sectionId}`);
    const colorPaletteClose = document.getElementById(`colorPaletteClose-${sectionId}`);
    
    // Color palette data - Expanded with 96 colors!
    const colorPalettes = {
        basic: [
            { name: 'Black', hex: '#000000' },
            { name: 'White', hex: '#FFFFFF' },
            { name: 'Red', hex: '#FF0000' },
            { name: 'Blue', hex: '#0000FF' },
            { name: 'Green', hex: '#00FF00' },
            { name: 'Yellow', hex: '#FFFF00' },
            { name: 'Orange', hex: '#FFA500' },
            { name: 'Purple', hex: '#800080' },
            { name: 'Gray', hex: '#808080' },
            { name: 'Brown', hex: '#A52A2A' },
            { name: 'Cyan', hex: '#00FFFF' },
            { name: 'Pink', hex: '#FFC0CB' }
        ],
        vibrant: [
            { name: 'Hot Pink', hex: '#FF69B4' },
            { name: 'Electric Blue', hex: '#00FFFF' },
            { name: 'Lime Green', hex: '#32CD32' },
            { name: 'Coral', hex: '#FF7F50' },
            { name: 'Magenta', hex: '#FF00FF' },
            { name: 'Turquoise', hex: '#40E0D0' },
            { name: 'Crimson', hex: '#DC143C' },
            { name: 'Gold', hex: '#FFD700' },
            { name: 'Neon Green', hex: '#39FF14' },
            { name: 'Neon Pink', hex: '#FF10F0' },
            { name: 'Bright Orange', hex: '#FF5F1F' },
            { name: 'Vivid Purple', hex: '#BF00FF' },
            { name: 'Spring Green', hex: '#00FF7F' },
            { name: 'Deep Sky Blue', hex: '#00BFFF' },
            { name: 'Tomato Red', hex: '#FF6347' },
            { name: 'Yellow Green', hex: '#9ACD32' }
        ],
        pastel: [
            { name: 'Baby Blue', hex: '#89CFF0' },
            { name: 'Mint Green', hex: '#98FF98' },
            { name: 'Lavender', hex: '#E6E6FA' },
            { name: 'Peach', hex: '#FFDAB9' },
            { name: 'Light Pink', hex: '#FFB6C1' },
            { name: 'Pale Yellow', hex: '#FFFFE0' },
            { name: 'Powder Blue', hex: '#B0E0E6' },
            { name: 'Cream', hex: '#FFFDD0' },
            { name: 'Light Coral', hex: '#F08080' },
            { name: 'Pale Green', hex: '#98FB98' },
            { name: 'Thistle', hex: '#D8BFD8' },
            { name: 'Misty Rose', hex: '#FFE4E1' },
            { name: 'Light Cyan', hex: '#E0FFFF' },
            { name: 'Lemon Chiffon', hex: '#FFFACD' },
            { name: 'Alice Blue', hex: '#F0F8FF' },
            { name: 'Honeydew', hex: '#F0FFF0' }
        ],
        dark: [
            { name: 'Navy Blue', hex: '#000080' },
            { name: 'Forest Green', hex: '#228B22' },
            { name: 'Maroon', hex: '#800000' },
            { name: 'Dark Purple', hex: '#301934' },
            { name: 'Charcoal', hex: '#36454F' },
            { name: 'Chocolate', hex: '#D2691E' },
            { name: 'Olive', hex: '#808000' },
            { name: 'Midnight', hex: '#191970' },
            { name: 'Dark Slate Gray', hex: '#2F4F4F' },
            { name: 'Saddle Brown', hex: '#8B4513' },
            { name: 'Dark Olive', hex: '#556B2F' },
            { name: 'Dark Red', hex: '#8B0000' },
            { name: 'Dark Green', hex: '#006400' },
            { name: 'Dark Cyan', hex: '#008B8B' },
            { name: 'Dark Magenta', hex: '#8B008B' },
            { name: 'Slate Gray', hex: '#708090' }
        ],
        special: [
            { name: 'Rose Gold', hex: '#B76E79' },
            { name: 'Silver', hex: '#C0C0C0' },
            { name: 'Bronze', hex: '#CD7F32' },
            { name: 'Copper', hex: '#B87333' },
            { name: 'Teal', hex: '#008080' },
            { name: 'Indigo', hex: '#4B0082' },
            { name: 'Aqua', hex: '#00FFFF' },
            { name: 'Salmon', hex: '#FA8072' },
            { name: 'Platinum', hex: '#E5E4E2' },
            { name: 'Champagne', hex: '#F7E7CE' },
            { name: 'Pearl', hex: '#EAE0C8' },
            { name: 'Sage', hex: '#BCB88A' },
            { name: 'Rust', hex: '#B7410E' },
            { name: 'Mauve', hex: '#E0B0FF' },
            { name: 'Burgundy', hex: '#800020' },
            { name: 'Plum', hex: '#DDA0DD' }
        ]
    };
    
    // Populate color samples
    function populateColorSamples() {
        Object.keys(colorPalettes).forEach(category => {
            const container = document.getElementById(`${category}Colors-${sectionId}`);
            if (container) {
                container.innerHTML = colorPalettes[category].map(color => `
                    <div class="cts-color-sample-${sectionId}" data-hex="${color.hex}">
                        <div class="cts-color-sample-box-${sectionId}" style="background: ${color.hex};"></div>
                        <div class="cts-color-sample-name-${sectionId}">${color.name}</div>
                        <div class="cts-color-sample-hex-${sectionId}">${color.hex}</div>
                    </div>
                `).join('');
            }
        });
        
        // Add click handlers to color samples
        document.querySelectorAll(`.cts-color-sample-${sectionId}`).forEach(sample => {
            sample.addEventListener('click', () => {
                const hex = sample.getAttribute('data-hex');
                selectColor(hex);
                closeModal();
            });
        });
    }
    
    // Select color
    function selectColor(hex) {
        currentColor = hex;
        designText.style.color = hex;
        hexInput.value = hex;
        hexPreview.style.background = hex;
        console.log(`🎨 Color selected from palette: ${hex}`);
    }
    
    // Open modal
    function openModal() {
        colorPaletteModal.classList.add('active');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
    
    // Close modal
    function closeModal() {
        colorPaletteModal.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
    }
    
    // Event listeners
    if (colorPaletteHelperBtn) {
        colorPaletteHelperBtn.addEventListener('click', openModal);
    }
    
    if (colorPaletteClose) {
        colorPaletteClose.addEventListener('click', closeModal);
    }
    
    // Close modal when clicking outside content
    if (colorPaletteModal) {
        colorPaletteModal.addEventListener('click', (e) => {
            if (e.target === colorPaletteModal) {
                closeModal();
            }
        });
    }
    
    // Close modal with Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && colorPaletteModal.classList.contains('active')) {
            closeModal();
        }
    });
    
    // Initialize color samples
    populateColorSamples();
    
    // Initialize thumbnail gallery
    initializeThumbnailGallery();
    
    // ============================================
    // TEXT & IMAGE CONTAINMENT SYSTEM
    // ============================================

    console.log('🎯 Loading complete containment system (text + images)...');

    // Configuration
    const CONTAINMENT_CONFIG = {
        maxWidth: 1.0,       // Changed to 100% - full width
        maxHeight: 1.0,      // Changed to 100% - full height
        padding: 0,          // Changed to 0 - no extra padding
        minFontSize: 14,
        maxFontSize: 72,
        imageMaxWidth: 0.90,
        imageMaxHeight: 0.90
    };

    // Get elements
    const cOverlay = document.getElementById(`designOverlay-${sectionId}`);
    const cText = document.getElementById(`designText-${sectionId}`);
    const cTextInput = document.getElementById(`textInput-${sectionId}`);
    const cSizeSlider = document.getElementById(`sizeSlider-${sectionId}`);
    const cSizeValue = document.getElementById(`sizeValue-${sectionId}`);
    const cImageUpload = document.getElementById(`imageUpload-${sectionId}`);

    // Track state
    let hasUploadedImage = false;
    let currentImageElement = null;

    // Verify elements exist
    if (!cOverlay || !cText) {
        console.error('❌ Containment: Required elements not found');
    } else {
        console.log('✅ Containment: Elements found successfully');
    }

    // Create warning indicator
    function createWarningIndicator() {
        if (document.getElementById(`containmentWarning-${sectionId}`)) {
            return document.getElementById(`containmentWarning-${sectionId}`);
        }
        
        const warning = document.createElement('div');
        warning.id = `containmentWarning-${sectionId}`;
        warning.style.cssText = `
            position: absolute;
            top: -50px;
            left: 50%;
            transform: translateX(-50%);
            background: linear-gradient(135deg, #ef4444, #dc2626);
            color: white;
            padding: 12px 20px;
            border-radius: 10px;
            font-size: 13px;
            font-weight: 600;
            display: none;
            z-index: 2000;
            box-shadow: 0 6px 16px rgba(239, 68, 68, 0.5);
            animation: warningPulse-${sectionId} 2s infinite, slideIn-${sectionId} 0.3s ease-out;
            white-space: nowrap;
            pointer-events: none;
        `;
        warning.innerHTML = '⚠️ Design exceeds print area';
        
        if (cOverlay) {
            if (window.getComputedStyle(cOverlay).position === 'static') {
                cOverlay.style.position = 'relative';
            }
            cOverlay.appendChild(warning);
            console.log('✅ Warning indicator created');
        }
        
        return warning;
    }

    const cWarning = createWarningIndicator();

    // Check if content fits
    function checkContentFit(element) {
        if (!element || !cOverlay) {
            return { fits: true, reason: 'Elements not found' };
        }
        
        try {
            const contentRect = element.getBoundingClientRect();
            const overlayRect = cOverlay.getBoundingClientRect();
            
            if (overlayRect.width === 0 || overlayRect.height === 0) {
                return { fits: true, reason: 'Not rendered yet' };
            }
            
            const maxWidth = overlayRect.width * CONTAINMENT_CONFIG.maxWidth - (CONTAINMENT_CONFIG.padding * 2);
            const maxHeight = overlayRect.height * CONTAINMENT_CONFIG.maxHeight - (CONTAINMENT_CONFIG.padding * 2);
            
            const exceedsWidth = contentRect.width > maxWidth;
            const exceedsHeight = contentRect.height > maxHeight;
            
            return {
                fits: !exceedsWidth && !exceedsHeight,
                exceedsWidth,
                exceedsHeight,
                contentWidth: contentRect.width,
                contentHeight: contentRect.height,
                maxWidth,
                maxHeight,
                usageWidth: ((contentRect.width / maxWidth) * 100).toFixed(1),
                usageHeight: ((contentRect.height / maxHeight) * 100).toFixed(1)
            };
        } catch (error) {
            console.error('Error checking fit:', error);
            return { fits: true, reason: 'Error' };
        }
    }

    // Check if overall design (text + image) fits
    function checkOverallFit() {
        let textFits = { fits: true };
        let imageFits = { fits: true };
        
        // Check text if visible
        if (cText && cText.style.display !== 'none') {
            textFits = checkContentFit(cText);
        }
        
        // Check image if present
        if (currentImageElement && currentImageElement.style.display !== 'none') {
            imageFits = checkContentFit(currentImageElement);
        }
        
        return {
            textFits: textFits.fits,
            imageFits: imageFits.fits,
            overallFits: textFits.fits && imageFits.fits,
            textData: textFits,
            imageData: imageFits
        };
    }

    // Auto-adjust text size
    function autoAdjustText() {
        if (!cText || !cOverlay) return;
        
        console.log('📏 Auto-adjusting text size...');
        
        let currentSize = parseInt(window.getComputedStyle(cText).fontSize);
        let fits = checkContentFit(cText);
        let iterations = 0;
        
        while (!fits.fits && currentSize > CONTAINMENT_CONFIG.minFontSize && iterations < 100) {
            currentSize -= 1;
            cText.style.fontSize = currentSize + 'px';
            fits = checkContentFit(cText);
            iterations++;
        }
        
        // Update slider
        if (cSizeSlider && cSizeValue) {
            cSizeSlider.value = currentSize;
            cSizeValue.textContent = currentSize;
        }
        
        if (fits.fits) {
            console.log(`✅ Text adjusted to ${currentSize}px (${fits.usageWidth}% width, ${fits.usageHeight}% height)`);
        } else {
            console.warn('⚠️ Text still too large at minimum size');
        }
        
        return fits.fits;
    }

    // Constrain uploaded image
    function constrainImage(img) {
        if (!img || !cOverlay) return;
        
        try {
            const overlayRect = cOverlay.getBoundingClientRect();
            if (overlayRect.width === 0) return;
            
            const maxWidth = (overlayRect.width * CONTAINMENT_CONFIG.imageMaxWidth) - (CONTAINMENT_CONFIG.padding * 2);
            const maxHeight = (overlayRect.height * CONTAINMENT_CONFIG.imageMaxHeight) - (CONTAINMENT_CONFIG.padding * 2);
            
            // Set max dimensions
            img.style.maxWidth = maxWidth + 'px';
            img.style.maxHeight = maxHeight + 'px';
            img.style.width = 'auto';
            img.style.height = 'auto';
            img.style.objectFit = 'contain';
            
            console.log(`🖼️ Image constrained: ${maxWidth.toFixed(0)}px × ${maxHeight.toFixed(0)}px`);
            
            // Check if it fits
            setTimeout(() => {
                const fits = checkContentFit(img);
                if (!fits.fits) {
                    console.warn('⚠️ Image still exceeds boundaries after constraint');
                } else {
                    console.log(`✅ Image fits: ${fits.usageWidth}% width, ${fits.usageHeight}% height`);
                }
            }, 100);
        } catch (error) {
            console.error('Error constraining image:', error);
        }
    }

    // Show warning
    function showWarning() {
        if (cWarning) cWarning.style.display = 'block';
        if (cOverlay) {
            cOverlay.style.outline = '3px solid #ef4444';
            cOverlay.style.outlineOffset = '4px';
        }
    }

    // Hide warning
    function hideWarning() {
        if (cWarning) cWarning.style.display = 'none';
        if (cOverlay) {
            cOverlay.style.outline = '';
            cOverlay.style.outlineOffset = '';
        }
    }

    // Apply word wrapping
    function applyWordWrapping() {
        if (!cText || !cOverlay) return;
        
        try {
            const overlayRect = cOverlay.getBoundingClientRect();
            if (overlayRect.width === 0) return;
            
            const maxWidth = (overlayRect.width * CONTAINMENT_CONFIG.maxWidth) - (CONTAINMENT_CONFIG.padding * 2);
            
            cText.style.maxWidth = maxWidth + 'px';
            cText.style.wordWrap = 'break-word';
            cText.style.overflowWrap = 'break-word';
            
            console.log('📐 Word wrapping applied');
        } catch (error) {
            console.error('Error applying wrapping:', error);
        }
    }

    // Monitor text input
    if (cTextInput) {
        cTextInput.addEventListener('input', function(e) {
            setTimeout(() => {
                applyWordWrapping();
                const overall = checkOverallFit();
                
                if (!overall.overallFits) {
                    showWarning();
                    if (!overall.textFits) {
                        console.log('📏 Text exceeds boundaries');
                    }
                } else {
                    hideWarning();
                }
            }, 100);
        });
        console.log('✅ Text input monitoring active');
    }

    // Monitor size slider
    if (cSizeSlider) {
        cSizeSlider.addEventListener('input', function(e) {
            setTimeout(() => {
                const overall = checkOverallFit();
                
                if (!overall.overallFits) {
                    showWarning();
                } else {
                    hideWarning();
                }
            }, 100);
        });
        console.log('✅ Size slider monitoring active');
    }

    // Enhanced image upload handler
    if (cImageUpload) {
        // Store original handler if exists
        const originalUploadHandler = cImageUpload.onchange;
        
        cImageUpload.addEventListener('change', function(e) {
            // Call original handler first if it exists
            if (originalUploadHandler) {
                originalUploadHandler.call(this, e);
            }
            
            const file = e.target.files[0];
            if (!file) return;
            
            console.log('📁 Image upload detected:', file.name);
            
            const reader = new FileReader();
            reader.onload = function(event) {
                // Wait a moment for existing handler to create/update image element
                setTimeout(() => {
                    // Find the image element (it should have been created by existing code)
                    currentImageElement = document.getElementById(`designImage-${sectionId}`);
                    
                    if (currentImageElement) {
                        hasUploadedImage = true;
                        
                        // Constrain the image
                        constrainImage(currentImageElement);
                        
                        // Check overall fit after image loads
                        currentImageElement.onload = function() {
                            setTimeout(() => {
                                const overall = checkOverallFit();
                                
                                if (!overall.overallFits) {
                                    showWarning();
                                    console.log('⚠️ Design (text + image) exceeds print area');
                                } else {
                                    hideWarning();
                                    console.log('✅ Design (text + image) fits within print area');
                                }
                            }, 200);
                        };
                        
                        console.log('✅ Image upload processed with containment');
                    } else {
                        console.warn('⚠️ Could not find image element after upload');
                    }
                }, 300);
            };
            reader.readAsDataURL(file);
        });
        console.log('✅ Image upload monitoring active');
    }

    // Add Auto-Fit button
    function addAutoFitButton() {
        if (document.getElementById(`containmentAutoFitBtn-${sectionId}`)) {
            console.log('ℹ️ Auto-fit button already exists');
            return;
        }
        
        const sizeGroup = cSizeSlider?.parentElement?.parentElement;
        if (!sizeGroup) {
            console.warn('⚠️ Could not find size slider group');
            return;
        }
        
        const autoFitBtn = document.createElement('button');
        autoFitBtn.id = `containmentAutoFitBtn-${sectionId}`;
        autoFitBtn.className = `cts-btn-${sectionId} cts-btn-secondary-${sectionId}`;
        autoFitBtn.style.marginTop = '10px';
        autoFitBtn.innerHTML = '📏 Auto-Fit Design to Print Area';
        autoFitBtn.type = 'button';
        
        autoFitBtn.onclick = function(e) {
            e.preventDefault();
            console.log('🎯 Auto-fit triggered');
            
            applyWordWrapping();
            
            // Adjust text
            if (cText && cText.style.display !== 'none') {
                autoAdjustText();
            }
            
            // Re-constrain image if present
            if (currentImageElement && currentImageElement.style.display !== 'none') {
                constrainImage(currentImageElement);
            }
            
            // Check overall result
            setTimeout(() => {
                const overall = checkOverallFit();
                if (!overall.overallFits) {
                    showWarning();
                    console.log('⚠️ Design still exceeds after auto-fit');
                } else {
                    hideWarning();
                    console.log('✅ Design now fits within print area');
                }
            }, 300);
        };
        
        if (sizeGroup.nextSibling) {
            sizeGroup.parentNode.insertBefore(autoFitBtn, sizeGroup.nextSibling);
        } else {
            sizeGroup.parentNode.appendChild(autoFitBtn);
        }
        
        console.log('✅ Auto-fit button added');
    }

    // Window resize handler
    let cResizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(cResizeTimeout);
        cResizeTimeout = setTimeout(() => {
            console.log('📱 Window resized, recalculating...');
            
            applyWordWrapping();
            
            // Re-constrain image if present
            if (currentImageElement) {
                constrainImage(currentImageElement);
            }
            
            // Check fit
            setTimeout(() => {
                const overall = checkOverallFit();
                if (!overall.overallFits) {
                    showWarning();
                } else {
                    hideWarning();
                }
            }, 100);
        }, 300);
    });

    // Initialize containment system
    function initCompleteContainment() {
        console.log('🎯 Initializing complete containment system...');
        console.log('📐 Config:', CONTAINMENT_CONFIG);
        
        setTimeout(() => {
            applyWordWrapping();
            addAutoFitButton();
            
            // Check for existing image
            const existingImage = document.getElementById(`designImage-${sectionId}`);
            if (existingImage) {
                currentImageElement = existingImage;
                hasUploadedImage = true;
                constrainImage(existingImage);
                console.log('🖼️ Found existing image, applying constraints');
            }
            
            // Initial check
            setTimeout(() => {
                const overall = checkOverallFit();
                
                if (cText && cText.textContent !== 'YOUR TEXT HERE') {
                    if (!overall.overallFits) {
                        showWarning();
                        console.log('⚠️ Initial design exceeds boundaries');
                    } else {
                        console.log('✅ Initial design fits');
                    }
                }
            }, 500);
        }, 1000);
        
        console.log('✅ Complete containment system initialized');
    }

    // Start initialization
    initCompleteContainment();

    console.log('🎨 Complete containment module loaded (text + images)');

    // Export functions for debugging
    window.ContainmentSystem = window.ContainmentSystem || {};
    window.ContainmentSystem[sectionId] = {
        checkOverallFit,
        checkContentFit,
        autoAdjustText,
        constrainImage,
        showWarning,
        hideWarning,
        config: CONTAINMENT_CONFIG
    };

    // ============================================
    // END COMPLETE CONTAINMENT SYSTEM
    // ============================================
    
    console.log('✅ Submit Request functionality initialized');
    console.log('✅ Designer integration points ready for enhancements');
    console.log('📱 Mobile touch gestures enabled (pinch-to-zoom, rotate)');
    console.log('🎨 Color Palette Helper initialized (76 colors available)');
    console.log('🖼️ Thumbnail Gallery initialized with 4 views');

    // ============================================
    // ENHANCED DEBUG CONTROL PANEL
    // Comprehensive metrics with collapsible sections
    // ============================================
    
    // Track metrics over time
    let metricsHistory = {
        adjustments: 0,
        lastAdjustTime: null,
        startTime: Date.now(),
        frames: 0
    };

    // Create Enhanced Debug Panel
    function createEnhancedDebugPanel() {
        // Check if panel already exists
        if (document.getElementById(`debugPanel-${sectionId}`)) {
            return;
        }

        const panel = document.createElement('div');
        panel.id = `debugPanel-${sectionId}`;
        panel.className = `cts-debug-panel-${sectionId}`;
        
        panel.innerHTML = `
            <div class="cts-debug-header-${sectionId}">
                <div class="cts-debug-title-${sectionId}">🔧 Print Area Debug Panel</div>
                <button class="cts-debug-close-${sectionId}" onclick="document.getElementById('debugPanel-${sectionId}').remove()">✕</button>
            </div>

            <!-- OVERALL STATUS -->
            <div class="cts-debug-status-${sectionId} fits" id="debugStatus-${sectionId}">
                ✓ Design Fits
            </div>

            <!-- SECTION: FIT ANALYSIS -->
            <div class="cts-debug-section-${sectionId}">
                <div class="cts-debug-section-header-${sectionId}" onclick="toggleSection(this)">
                    <div class="cts-debug-section-title-${sectionId}">🎯 Fit Analysis</div>
                    <div class="cts-debug-section-toggle-${sectionId}">▼</div>
                </div>
                <div class="cts-debug-section-content-${sectionId}">
                    <div class="cts-debug-indicator-grid-${sectionId}">
                        <div class="cts-debug-indicator-${sectionId} fits" id="debugWidthFit-${sectionId}">✓ Width Fits</div>
                        <div class="cts-debug-indicator-${sectionId} fits" id="debugHeightFit-${sectionId}">✓ Height Fits</div>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}" style="margin-top: 12px;">
                        <span class="cts-debug-label-${sectionId}">Width Utilization</span>
                        <span class="cts-debug-value-${sectionId}" id="debugWidthUtil-${sectionId}">0%</span>
                    </div>
                    <div class="cts-debug-progress-${sectionId}">
                        <div class="cts-debug-progress-bar-${sectionId}" id="debugWidthBar-${sectionId}" style="width: 0%"></div>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Height Utilization</span>
                        <span class="cts-debug-value-${sectionId}" id="debugHeightUtil-${sectionId}">0%</span>
                    </div>
                    <div class="cts-debug-progress-${sectionId}">
                        <div class="cts-debug-progress-bar-${sectionId}" id="debugHeightBar-${sectionId}" style="width: 0%"></div>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Overflow (Width)</span>
                        <span class="cts-debug-value-${sectionId}" id="debugOverflowWidth-${sectionId}">0px</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Overflow (Height)</span>
                        <span class="cts-debug-value-${sectionId}" id="debugOverflowHeight-${sectionId}">0px</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Safety Margin</span>
                        <span class="cts-debug-value-${sectionId}" id="debugSafetyMargin-${sectionId}">0px</span>
                    </div>
                </div>
            </div>

            <!-- SECTION: DIMENSIONS -->
            <div class="cts-debug-section-${sectionId}">
                <div class="cts-debug-section-header-${sectionId}" onclick="toggleSection(this)">
                    <div class="cts-debug-section-title-${sectionId}">📐 Dimensions</div>
                    <div class="cts-debug-section-toggle-${sectionId}">▼</div>
                </div>
                <div class="cts-debug-section-content-${sectionId}">
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Print Area Width</span>
                        <span class="cts-debug-value-${sectionId}" id="debugPrintWidth-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Print Area Height</span>
                        <span class="cts-debug-value-${sectionId}" id="debugPrintHeight-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Max Allowed Text Width</span>
                        <span class="cts-debug-value-${sectionId}" id="debugMaxTextWidth-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Max Allowed Text Height</span>
                        <span class="cts-debug-value-${sectionId}" id="debugMaxTextHeight-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Text Width</span>
                        <span class="cts-debug-value-${sectionId}" id="debugTextWidth-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Text Height</span>
                        <span class="cts-debug-value-${sectionId}" id="debugTextHeight-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Image Width</span>
                        <span class="cts-debug-value-${sectionId}" id="debugImageWidth-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Image Height</span>
                        <span class="cts-debug-value-${sectionId}" id="debugImageHeight-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Aspect Ratio (Text)</span>
                        <span class="cts-debug-value-${sectionId}" id="debugAspectRatio-${sectionId}">-</span>
                    </div>
                </div>
            </div>

            <!--SECTION: EDGE DISTANCES -->
            <div class="cts-debug-section-${sectionId}">
                <div class="cts-debug-section-header-${sectionId}" onclick="toggleSection(this)">
                    <div class="cts-debug-section-title-${sectionId}">📍 Edge Distances</div>
                    <div class="cts-debug-section-toggle-${sectionId} collapsed">▼</div>
                </div>
                <div class="cts-debug-section-content-${sectionId} collapsed">
                    <div class="cts-debug-edge-distances-${sectionId}">
                        <div></div>
                        <div class="cts-debug-edge-${sectionId}" id="debugEdgeTop-${sectionId}">Top: -</div>
                        <div></div>
                        
                        <div class="cts-debug-edge-${sectionId}" id="debugEdgeLeft-${sectionId}">Left: -</div>
                        <div class="cts-debug-edge-${sectionId} center">TEXT</div>
                        <div class="cts-debug-edge-${sectionId}" id="debugEdgeRight-${sectionId}">Right: -</div>
                        
                        <div></div>
                        <div class="cts-debug-edge-${sectionId}" id="debugEdgeBottom-${sectionId}">Bottom: -</div>
                        <div></div>
                    </div>
                </div>
            </div>

            <!-- SECTION: CONTENT ANALYSIS -->
            <div class="cts-debug-section-${sectionId}">
                <div class="cts-debug-section-header-${sectionId}" onclick="toggleSection(this)">
                    <div class="cts-debug-section-title-${sectionId}">📝 Content Analysis</div>
                    <div class="cts-debug-section-toggle-${sectionId} collapsed">▼</div>
                </div>
                <div class="cts-debug-section-content-${sectionId} collapsed">
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Character Count</span>
                        <span class="cts-debug-value-${sectionId}" id="debugCharCount-${sectionId}">0</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Word Count</span>
                        <span class="cts-debug-value-${sectionId}" id="debugWordCount-${sectionId}">0</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Font Size</span>
                        <span class="cts-debug-value-${sectionId}" id="debugFontSize-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Line Count (Est.)</span>
                        <span class="cts-debug-value-${sectionId}" id="debugLineCount-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Text Density</span>
                        <span class="cts-debug-value-${sectionId}" id="debugTextDensity-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Content Ratio (Text:Image)</span>
                        <span class="cts-debug-value-${sectionId}" id="debugContentRatio-${sectionId}">-</span>
                    </div>
                </div>
            </div>

            <!-- SECTION: POSITION & TRANSFORM -->
            <div class="cts-debug-section-${sectionId}">
                <div class="cts-debug-section-header-${sectionId}" onclick="toggleSection(this)">
                    <div class="cts-debug-section-title-${sectionId}">🎯 Position & Transform</div>
                    <div class="cts-debug-section-toggle-${sectionId} collapsed">▼</div>
                </div>
                <div class="cts-debug-section-content-${sectionId} collapsed">
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">X Position</span>
                        <span class="cts-debug-value-${sectionId}" id="debugPosX-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Y Position</span>
                        <span class="cts-debug-value-${sectionId}" id="debugPosY-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Rotation</span>
                        <span class="cts-debug-value-${sectionId}" id="debugRotation-${sectionId}">0°</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Scale</span>
                        <span class="cts-debug-value-${sectionId}" id="debugScale-${sectionId}">100%</span>
                    </div>
                </div>
            </div>

            <!-- SECTION: PERFORMANCE -->
            <div class="cts-debug-section-${sectionId}">
                <div class="cts-debug-section-header-${sectionId}" onclick="toggleSection(this)">
                    <div class="cts-debug-section-title-${sectionId}">⚡ Performance</div>
                    <div class="cts-debug-section-toggle-${sectionId} collapsed">▼</div>
                </div>
                <div class="cts-debug-section-content-${sectionId} collapsed">
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Adjustment Iterations</span>
                        <span class="cts-debug-value-${sectionId}" id="debugIterations-${sectionId}">0</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Last Adjustment</span>
                        <span class="cts-debug-value-${sectionId} muted" id="debugLastAdjust-${sectionId}">Never</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Render FPS</span>
                        <span class="cts-debug-value-${sectionId}" id="debugFPS-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Uptime</span>
                        <span class="cts-debug-value-${sectionId} muted" id="debugUptime-${sectionId}">0s</span>
                    </div>
                </div>
            </div>

            <!-- SECTION: PRINT-READY VALIDATION -->
            <div class="cts-debug-section-${sectionId}">
                <div class="cts-debug-section-header-${sectionId}" onclick="toggleSection(this)">
                    <div class="cts-debug-section-title-${sectionId}">🖨️ Print-Ready Info</div>
                    <div class="cts-debug-section-toggle-${sectionId} collapsed">▼</div>
                </div>
                <div class="cts-debug-section-content-${sectionId} collapsed">
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Est. Physical Size</span>
                        <span class="cts-debug-value-${sectionId}" id="debugPhysicalSize-${sectionId}">-</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Resolution (DPI)</span>
                        <span class="cts-debug-value-${sectionId}" id="debugDPI-${sectionId}">Screen</span>
                    </div>
                    
                    <div class="cts-debug-metric-${sectionId}">
                        <span class="cts-debug-label-${sectionId}">Print Quality</span>
                        <span class="cts-debug-value-${sectionId} success" id="debugPrintQuality-${sectionId}">Excellent</span>
                    </div>
                </div>
            </div>

            <!-- SECTION: ADJUSTABLE CONFIG -->
            <div class="cts-debug-section-${sectionId}">
                <div class="cts-debug-section-header-${sectionId}" onclick="toggleSection(this)">
                    <div class="cts-debug-section-title-${sectionId}">⚙️ Adjustable Config</div>
                    <div class="cts-debug-section-toggle-${sectionId} collapsed">▼</div>
                </div>
                <div class="cts-debug-section-content-${sectionId} collapsed">
                
                <!-- Text Max Width -->
                <div class="cts-debug-slider-group-${sectionId}">
                    <div class="cts-debug-label-${sectionId}">Text Max Width (%)</div>
                    <input type="range" class="cts-debug-slider-${sectionId}" 
                           id="debugMaxWidth-${sectionId}" 
                           min="50" max="100" step="1" value="100">
                    <div class="cts-debug-slider-label-${sectionId}">
                        <span>50%</span>
                        <span id="debugMaxWidthVal-${sectionId}">100%</span>
                        <span>100%</span>
                    </div>
                </div>

                <!-- Text Max Height -->
                <div class="cts-debug-slider-group-${sectionId}">
                    <div class="cts-debug-label-${sectionId}">Text Max Height (%)</div>
                    <input type="range" class="cts-debug-slider-${sectionId}" 
                           id="debugMaxHeight-${sectionId}" 
                           min="50" max="100" step="1" value="100">
                    <div class="cts-debug-slider-label-${sectionId}">
                        <span>50%</span>
                        <span id="debugMaxHeightVal-${sectionId}">100%</span>
                        <span>100%</span>
                    </div>
                </div>

                <!-- Image Max Width -->
                <div class="cts-debug-slider-group-${sectionId}">
                    <div class="cts-debug-label-${sectionId}">Image Max Width (%)</div>
                    <input type="range" class="cts-debug-slider-${sectionId}" 
                           id="debugImageMaxWidth-${sectionId}" 
                           min="50" max="100" step="1" value="90">
                    <div class="cts-debug-slider-label-${sectionId}">
                        <span>50%</span>
                        <span id="debugImageMaxWidthVal-${sectionId}">90%</span>
                        <span>100%</span>
                    </div>
                </div>

                <!-- Image Max Height -->
                <div class="cts-debug-slider-group-${sectionId}">
                    <div class="cts-debug-label-${sectionId}">Image Max Height (%)</div>
                    <input type="range" class="cts-debug-slider-${sectionId}" 
                           id="debugImageMaxHeight-${sectionId}" 
                           min="50" max="100" step="1" value="90">
                    <div class="cts-debug-slider-label-${sectionId}">
                        <span>50%</span>
                        <span id="debugImageMaxHeightVal-${sectionId}">90%</span>
                        <span>100%</span>
                    </div>
                </div>

                <!-- Padding -->
                <div class="cts-debug-slider-group-${sectionId}">
                    <div class="cts-debug-label-${sectionId}">Padding (px)</div>
                    <input type="range" class="cts-debug-slider-${sectionId}" 
                           id="debugPadding-${sectionId}" 
                           min="0" max="50" step="1" value="0">
                    <div class="cts-debug-slider-label-${sectionId}">
                        <span>0px</span>
                        <span id="debugPaddingVal-${sectionId}">0px</span>
                        <span>50px</span>
                    </div>
                </div>

                <!-- Min Font Size -->
                <div class="cts-debug-slider-group-${sectionId}">
                    <div class="cts-debug-label-${sectionId}">Min Font Size (px)</div>
                    <input type="range" class="cts-debug-slider-${sectionId}" 
                           id="debugMinFontSize-${sectionId}" 
                           min="8" max="30" step="1" value="14">
                    <div class="cts-debug-slider-label-${sectionId}">
                        <span>8px</span>
                        <span id="debugMinFontSizeVal-${sectionId}">14px</span>
                        <span>30px</span>
                    </div>
                </div>

                <!-- Max Font Size -->
                <div class="cts-debug-slider-group-${sectionId}">
                    <div class="cts-debug-label-${sectionId}">Max Font Size (px)</div>
                    <input type="range" class="cts-debug-slider-${sectionId}" 
                           id="debugMaxFontSize-${sectionId}" 
                           min="30" max="120" step="2" value="72">
                    <div class="cts-debug-slider-label-${sectionId}">
                        <span>30px</span>
                        <span id="debugMaxFontSizeVal-${sectionId}">72px</span>
                        <span>120px</span>
                    </div>
                </div>

                </div>
            </div>

            <!-- ACTION BUTTONS -->
            <button class="cts-debug-btn-${sectionId} cts-debug-btn-primary-${sectionId}" id="debugReset-${sectionId}">
                🔄 Reset to Defaults
            </button>

            <button class="cts-debug-btn-${sectionId} cts-debug-btn-secondary-${sectionId}" id="debugExport-${sectionId}">
                📋 Copy Config to Clipboard
            </button>

            <button class="cts-debug-btn-${sectionId} cts-debug-btn-secondary-${sectionId}" id="debugSnapshot-${sectionId}">
                📸 Export Metrics Snapshot
            </button>
        `;

        document.body.appendChild(panel);
        
        // Make toggleSection function global for onclick handlers
        window.toggleSection = function(header) {
            const content = header.nextElementSibling;
            const toggle = header.querySelector(`.cts-debug-section-toggle-${sectionId}`);
            
            content.classList.toggle('collapsed');
            toggle.classList.toggle('collapsed');
        };
        
        // Setup event listeners
        setupDebugControls();
        
        // Start real-time updates
        startRealTimeUpdates();
        
        console.log('✅ Enhanced debug panel created');
    }

    // Setup controls
    function setupDebugControls() {
        // Get sliders
        const maxWidthSlider = document.getElementById(`debugMaxWidth-${sectionId}`);
        const maxHeightSlider = document.getElementById(`debugMaxHeight-${sectionId}`);
        const imageMaxWidthSlider = document.getElementById(`debugImageMaxWidth-${sectionId}`);
        const imageMaxHeightSlider = document.getElementById(`debugImageMaxHeight-${sectionId}`);
        const paddingSlider = document.getElementById(`debugPadding-${sectionId}`);
        const minFontSlider = document.getElementById(`debugMinFontSize-${sectionId}`);
        const maxFontSlider = document.getElementById(`debugMaxFontSize-${sectionId}`);
        
        const resetBtn = document.getElementById(`debugReset-${sectionId}`);
        const exportBtn = document.getElementById(`debugExport-${sectionId}`);
        const snapshotBtn = document.getElementById(`debugSnapshot-${sectionId}`);

        // Update CONTAINMENT_CONFIG when sliders change
        function updateConfig() {
            if (window.ContainmentSystem && window.ContainmentSystem[sectionId]) {
                const config = window.ContainmentSystem[sectionId].config;
                
                config.maxWidth = parseFloat(maxWidthSlider.value) / 100;
                config.maxHeight = parseFloat(maxHeightSlider.value) / 100;
                config.imageMaxWidth = parseFloat(imageMaxWidthSlider.value) / 100;
                config.imageMaxHeight = parseFloat(imageMaxHeightSlider.value) / 100;
                config.padding = parseInt(paddingSlider.value);
                config.minFontSize = parseInt(minFontSlider.value);
                config.maxFontSize = parseInt(maxFontSlider.value);
                
                // Update displays
                document.getElementById(`debugMaxWidthVal-${sectionId}`).textContent = maxWidthSlider.value + '%';
                document.getElementById(`debugMaxHeightVal-${sectionId}`).textContent = maxHeightSlider.value + '%';
                document.getElementById(`debugImageMaxWidthVal-${sectionId}`).textContent = imageMaxWidthSlider.value + '%';
                document.getElementById(`debugImageMaxHeightVal-${sectionId}`).textContent = imageMaxHeightSlider.value + '%';
                document.getElementById(`debugPaddingVal-${sectionId}`).textContent = paddingSlider.value + 'px';
                document.getElementById(`debugMinFontSizeVal-${sectionId}`).textContent = minFontSlider.value + 'px';
                document.getElementById(`debugMaxFontSizeVal-${sectionId}`).textContent = maxFontSlider.value + 'px';
                
                metricsHistory.adjustments++;
                metricsHistory.lastAdjustTime = Date.now();
                
                console.log('📐 Config updated:', config);
            }
        }

        // Add event listeners
        if (maxWidthSlider) maxWidthSlider.addEventListener('input', updateConfig);
        if (maxHeightSlider) maxHeightSlider.addEventListener('input', updateConfig);
        if (imageMaxWidthSlider) imageMaxWidthSlider.addEventListener('input', updateConfig);
        if (imageMaxHeightSlider) imageMaxHeightSlider.addEventListener('input', updateConfig);
        if (paddingSlider) paddingSlider.addEventListener('input', updateConfig);
        if (minFontSlider) minFontSlider.addEventListener('input', updateConfig);
        if (maxFontSlider) maxFontSlider.addEventListener('input', updateConfig);

        // Reset button
        if (resetBtn) {
            resetBtn.addEventListener('click', () => {
                maxWidthSlider.value = 100;
                maxHeightSlider.value = 100;
                imageMaxWidthSlider.value = 90;
                imageMaxHeightSlider.value = 90;
                paddingSlider.value = 0;
                minFontSlider.value = 14;
                maxFontSlider.value = 72;
                updateConfig();
                console.log('🔄 Config reset to defaults');
            });
        }

        // Export button
        if (exportBtn) {
            exportBtn.addEventListener('click', () => {
                if (window.ContainmentSystem && window.ContainmentSystem[sectionId]) {
                    const config = window.ContainmentSystem[sectionId].config;
                    const configText = `const CONTAINMENT_CONFIG = {
    maxWidth: ${config.maxWidth},
    maxHeight: ${config.maxHeight},
    padding: ${config.padding},
    minFontSize: ${config.minFontSize},
    maxFontSize: ${config.maxFontSize},
    imageMaxWidth: ${config.imageMaxWidth},
    imageMaxHeight: ${config.imageMaxHeight}
};`;
                    
                    navigator.clipboard.writeText(configText).then(() => {
                        exportBtn.textContent = '✅ Copied!';
                        setTimeout(() => {
                            exportBtn.textContent = '📋 Copy Config to Clipboard';
                        }, 2000);
                    });
                }
            });
        }

        // Snapshot button
        if (snapshotBtn) {
            snapshotBtn.addEventListener('click', () => {
                const snapshot = captureMetricsSnapshot();
                const snapshotText = JSON.stringify(snapshot, null, 2);
                
                navigator.clipboard.writeText(snapshotText).then(() => {
                    snapshotBtn.textContent = '✅ Snapshot Copied!';
                    setTimeout(() => {
                        snapshotBtn.textContent = '📸 Export Metrics Snapshot';
                    }, 2000);
                    console.log('📸 Metrics snapshot:', snapshot);
                });
            });
        }
    }

    // Capture full metrics snapshot
    function captureMetricsSnapshot() {
        const cOverlay = document.getElementById(`designOverlay-${sectionId}`);
        const cText = document.getElementById(`designText-${sectionId}`);
        const cImage = document.getElementById(`designImage-${sectionId}`);
        
        const snapshot = {
            timestamp: new Date().toISOString(),
            printArea: {},
            text: {},
            image: {},
            fit: {},
            config: {}
        };

        if (cOverlay) {
            const rect = cOverlay.getBoundingClientRect();
            snapshot.printArea = {
                width: rect.width,
                height: rect.height
            };
        }

        if (cText && cText.style.display !== 'none') {
            const rect = cText.getBoundingClientRect();
            const style = window.getComputedStyle(cText);
            snapshot.text = {
                width: rect.width,
                height: rect.height,
                fontSize: style.fontSize,
                content: cText.textContent,
                characterCount: cText.textContent.length,
                wordCount: cText.textContent.split(/\s+/).filter(w => w).length
            };
        }

        if (cImage && cImage.style.display !== 'none') {
            const rect = cImage.getBoundingClientRect();
            snapshot.image = {
                width: rect.width,
                height: rect.height
            };
        }

        if (window.ContainmentSystem && window.ContainmentSystem[sectionId]) {
            const fitResult = window.ContainmentSystem[sectionId].checkOverallFit();
            snapshot.fit = fitResult;
            snapshot.config = window.ContainmentSystem[sectionId].config;
        }

        return snapshot;
    }

    // Real-time metric updates
    let lastFrameTime = Date.now();
    let frameCount = 0;
    let fps = 0;

    function startRealTimeUpdates() {
        setInterval(() => {
            updateDebugMetrics();
            
            // Calculate FPS
            frameCount++;
            const now = Date.now();
            if (now - lastFrameTime >= 1000) {
                fps = frameCount;
                frameCount = 0;
                lastFrameTime = now;
            }
        }, 100); // Update every 100ms
    }

    function updateDebugMetrics() {
        const cOverlay = document.getElementById(`designOverlay-${sectionId}`);
        const cText = document.getElementById(`designText-${sectionId}`);
        const cImage = document.getElementById(`designImage-${sectionId}`);

        if (!cOverlay) return;

        const overlayRect = cOverlay.getBoundingClientRect();
        const config = window.ContainmentSystem?.[sectionId]?.config || {};
        
        // Calculate max allowed dimensions
        const maxTextWidth = (overlayRect.width * (config.maxWidth || 0.95)) - ((config.padding || 8) * 2);
        const maxTextHeight = (overlayRect.height * (config.maxHeight || 0.95)) - ((config.padding || 8) * 2);
        
        // Update print area dimensions
        updateElement(`debugPrintWidth-${sectionId}`, Math.round(overlayRect.width) + 'px');
        updateElement(`debugPrintHeight-${sectionId}`, Math.round(overlayRect.height) + 'px');
        updateElement(`debugMaxTextWidth-${sectionId}`, Math.round(maxTextWidth) + 'px');
        updateElement(`debugMaxTextHeight-${sectionId}`, Math.round(maxTextHeight) + 'px');

        // Update text dimensions and analysis
        if (cText && cText.style.display !== 'none') {
            const textRect = cText.getBoundingClientRect();
            const computedStyle = window.getComputedStyle(cText);
            const content = cText.textContent || '';
            
            updateElement(`debugTextWidth-${sectionId}`, Math.round(textRect.width) + 'px');
            updateElement(`debugTextHeight-${sectionId}`, Math.round(textRect.height) + 'px');
            updateElement(`debugFontSize-${sectionId}`, computedStyle.fontSize);
            
            // Calculate utilization
            const widthUtil = (textRect.width / maxTextWidth * 100).toFixed(1);
            const heightUtil = (textRect.height / maxTextHeight * 100).toFixed(1);
            
            updateElement(`debugWidthUtil-${sectionId}`, widthUtil + '%');
            updateElement(`debugHeightUtil-${sectionId}`, heightUtil + '%');
            
            // Update progress bars
            const widthBar = document.getElementById(`debugWidthBar-${sectionId}`);
            const heightBar = document.getElementById(`debugHeightBar-${sectionId}`);
            
            if (widthBar) {
                widthBar.style.width = Math.min(widthUtil, 100) + '%';
                widthBar.className = `cts-debug-progress-bar-${sectionId}`;
                if (widthUtil > 100) widthBar.classList.add('danger');
                else if (widthUtil > 90) widthBar.classList.add('warning');
            }
            
            if (heightBar) {
                heightBar.style.width = Math.min(heightUtil, 100) + '%';
                heightBar.className = `cts-debug-progress-bar-${sectionId}`;
                if (heightUtil > 100) heightBar.classList.add('danger');
                else if (heightUtil > 90) heightBar.classList.add('warning');
            }
            
            // Calculate overflow
            const overflowWidth = Math.max(0, textRect.width - maxTextWidth);
            const overflowHeight = Math.max(0, textRect.height - maxTextHeight);
            
            updateElement(`debugOverflowWidth-${sectionId}`, 
                overflowWidth > 0 ? `+${Math.round(overflowWidth)}px` : '0px',
                overflowWidth > 0 ? 'danger' : 'success');
            updateElement(`debugOverflowHeight-${sectionId}`, 
                overflowHeight > 0 ? `+${Math.round(overflowHeight)}px` : '0px',
                overflowHeight > 0 ? 'danger' : 'success');
            
            // Safety margin
            const safetyMargin = Math.min(maxTextWidth - textRect.width, maxTextHeight - textRect.height);
            updateElement(`debugSafetyMargin-${sectionId}`, 
                safetyMargin > 0 ? Math.round(safetyMargin) + 'px' : '0px',
                safetyMargin > 10 ? 'success' : safetyMargin > 0 ? 'warning' : 'danger');
            
            // Aspect ratio
            const aspectRatio = (textRect.width / textRect.height).toFixed(2);
            updateElement(`debugAspectRatio-${sectionId}`, aspectRatio + ':1');
            
            // Content analysis
            updateElement(`debugCharCount-${sectionId}`, content.length);
            const words = content.split(/\s+/).filter(w => w);
            updateElement(`debugWordCount-${sectionId}`, words.length);
            
            // Estimate line count
            const fontSize = parseFloat(computedStyle.fontSize);
            const lineHeight = parseFloat(computedStyle.lineHeight) || fontSize * 1.2;
            const estimatedLines = Math.ceil(textRect.height / lineHeight);
            updateElement(`debugLineCount-${sectionId}`, estimatedLines);
            
            // Text density (chars per line)
            const density = estimatedLines > 0 ? (content.length / estimatedLines).toFixed(1) : '0';
            updateElement(`debugTextDensity-${sectionId}`, density + ' chars/line');
            
            // Edge distances
            const printRect = overlayRect;
            const edges = {
                top: textRect.top - printRect.top,
                right: printRect.right - textRect.right,
                bottom: printRect.bottom - textRect.bottom,
                left: textRect.left - printRect.left
            };
            
            updateElement(`debugEdgeTop-${sectionId}`, `Top: ${Math.round(edges.top)}px`);
            updateElement(`debugEdgeRight-${sectionId}`, `Right: ${Math.round(edges.right)}px`);
            updateElement(`debugEdgeBottom-${sectionId}`, `Bottom: ${Math.round(edges.bottom)}px`);
            updateElement(`debugEdgeLeft-${sectionId}`, `Left: ${Math.round(edges.left)}px`);
            
            // Position
            const centerX = printRect.left + (printRect.width / 2);
            const centerY = printRect.top + (printRect.height / 2);
            const textCenterX = textRect.left + (textRect.width / 2);
            const textCenterY = textRect.top + (textRect.height / 2);
            
            updateElement(`debugPosX-${sectionId}`, Math.round(textCenterX - centerX) + 'px');
            updateElement(`debugPosY-${sectionId}`, Math.round(textCenterY - centerY) + 'px');
        } else {
            updateElement(`debugTextWidth-${sectionId}`, 'N/A', 'muted');
            updateElement(`debugTextHeight-${sectionId}`, 'N/A', 'muted');
            updateElement(`debugFontSize-${sectionId}`, 'N/A', 'muted');
            updateElement(`debugWidthUtil-${sectionId}`, '0%');
            updateElement(`debugHeightUtil-${sectionId}`, '0%');
        }

        // Update image dimensions
        if (cImage && cImage.style.display !== 'none') {
            const imageRect = cImage.getBoundingClientRect();
            updateElement(`debugImageWidth-${sectionId}`, Math.round(imageRect.width) + 'px');
            updateElement(`debugImageHeight-${sectionId}`, Math.round(imageRect.height) + 'px');
            
            // Calculate content ratio
            const textArea = cText ? cText.getBoundingClientRect().width * cText.getBoundingClientRect().height : 0;
            const imageArea = imageRect.width * imageRect.height;
            const ratio = textArea > 0 ? (textArea / imageArea).toFixed(2) : '0';
            updateElement(`debugContentRatio-${sectionId}`, `${ratio}:1`);
        } else {
            updateElement(`debugImageWidth-${sectionId}`, 'N/A', 'muted');
            updateElement(`debugImageHeight-${sectionId}`, 'N/A', 'muted');
            updateElement(`debugContentRatio-${sectionId}`, 'Text only');
        }

        // Check fit status
        if (window.ContainmentSystem && window.ContainmentSystem[sectionId]) {
            const fitResult = window.ContainmentSystem[sectionId].checkOverallFit();
            const statusEl = document.getElementById(`debugStatus-${sectionId}`);
            const widthFitEl = document.getElementById(`debugWidthFit-${sectionId}`);
            const heightFitEl = document.getElementById(`debugHeightFit-${sectionId}`);
            
            // Overall status
            if (statusEl) {
                if (fitResult.overallFits) {
                    statusEl.className = `cts-debug-status-${sectionId} fits`;
                    statusEl.textContent = '✓ Design Fits';
                } else {
                    statusEl.className = `cts-debug-status-${sectionId} exceeds`;
                    statusEl.textContent = '⚠ Design Exceeds Print Area';
                }
            }
            
            // Width fit indicator
            if (widthFitEl) {
                if (fitResult.textFits || !cText || cText.style.display === 'none') {
                    widthFitEl.className = `cts-debug-indicator-${sectionId} fits`;
                    widthFitEl.textContent = '✓ Width Fits';
                } else {
                    widthFitEl.className = `cts-debug-indicator-${sectionId} exceeds`;
                    widthFitEl.textContent = '✗ Width Exceeds';
                }
            }
            
            // Height fit indicator
            if (heightFitEl) {
                if (fitResult.textFits || !cText || cText.style.display === 'none') {
                    heightFitEl.className = `cts-debug-indicator-${sectionId} fits`;
                    heightFitEl.textContent = '✓ Height Fits';
                } else {
                    heightFitEl.className = `cts-debug-indicator-${sectionId} exceeds`;
                    heightFitEl.textContent = '✗ Height Exceeds';
                }
            }
        }

        // Performance metrics
        updateElement(`debugIterations-${sectionId}`, metricsHistory.adjustments);
        
        if (metricsHistory.lastAdjustTime) {
            const elapsed = Math.round((Date.now() - metricsHistory.lastAdjustTime) / 1000);
            updateElement(`debugLastAdjust-${sectionId}`, elapsed + 's ago', 'muted');
        }
        
        updateElement(`debugFPS-${sectionId}`, fps + ' fps');
        
        const uptime = Math.round((Date.now() - metricsHistory.startTime) / 1000);
        updateElement(`debugUptime-${sectionId}`, uptime + 's', 'muted');
        
        // Print-ready info
        const printWidthInches = (overlayRect.width / 96).toFixed(1); // Assuming 96 DPI screen
        const printHeightInches = (overlayRect.height / 96).toFixed(1);
        updateElement(`debugPhysicalSize-${sectionId}`, `${printWidthInches}" × ${printHeightInches}"`);
        
        // Estimate print quality based on size
        const minDimension = Math.min(overlayRect.width, overlayRect.height);
        let quality = 'Excellent';
        let qualityClass = 'success';
        if (minDimension < 200) {
            quality = 'Poor';
            qualityClass = 'danger';
        } else if (minDimension < 300) {
            quality = 'Fair';
            qualityClass = 'warning';
        } else if (minDimension < 400) {
            quality = 'Good';
            qualityClass = 'success';
        }
        updateElement(`debugPrintQuality-${sectionId}`, quality, qualityClass);
    }

    // Helper function to update elements
    function updateElement(id, text, className = null) {
        const el = document.getElementById(id);
        if (el) {
            el.textContent = text;
            if (className) {
                el.className = `cts-debug-value-${sectionId} ${className}`;
            }
        }
    }

    // Initialize enhanced debug panel after a short delay
    setTimeout(() => {
        createEnhancedDebugPanel();
        console.log('🔧 Enhanced debug control panel initialized');
    }, 2000);

    // ============================================
    // END DEBUG CONTROL PANEL
    // ============================================

})();